import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import "./styles.css";
import "./screen.css";
import axios from "axios";
import Loader from "./Loader";
import SliderCard from "./SliderCard";
import { MqttContext } from "../mqtt/MqttContext";
import {
  acid_impact_time,
  acid_pump_time,
  impact_time,
  pool_size,
  pump_time,
} from "./config";
import Sidebar from "./SideBar";
const API_URL = process.env.REACT_APP_API_URL;
function Settings() {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.id || "No message received";
  const [loading, setloading] = useState(false);
  const [pumpMode1, setPumpMode1] = useState("");
  const [pumpMode2, setPumpMode2] = useState("");
  const [pumpMode3, setPumpMode3] = useState("");
  const [loading2, setloading2] = useState(true);
  const [threshold, setThreshold] = useState({});
  const [showSidebar, setShowSidebar] = useState(false);
  const mac = location.state?.id;
  const [phlow, setphlow] = useState(0);
  const [phhigh, setphhigh] = useState(0);
  const [name, setname] = useState("");
  const [orplow, setorplow] = useState(0);
  const [orphigh, setorphigh] = useState(0);
  const [dolow, setdolow] = useState(0);
  const [dohigh, setdohigh] = useState(0);
  const [templow, settemplow] = useState(0);
  const [temphigh, settemphigh] = useState(0);
  const [vollow, setvollow] = useState(0);
  const [volhigh, setvolhigh] = useState(0);
  const [currlow, setcurrlow] = useState(0);
  const [currentHigh, setcurrentHigh] = useState(0);
  const [c_phlow, setc_phlow] = useState(0);
  const [c_phhigh, setc_phhigh] = useState(0);
  const [c_orplow, setc_orplow] = useState(0);
  const [c_orphigh, setc_orphigh] = useState(0);
  const [c_dolow, setc_dolow] = useState(0);
  const [c_dohigh, setc_dohigh] = useState(0);
  const [c_templow, setc_templow] = useState(0);

  const [Acid_pump_time, setAcid_pump_time] = useState(0);
  const [Chlorine_pump_time, setChlorine_pump_time] = useState(0);
  const [Other_pump_time, setOther_pump_time] = useState(0);

  const [c_temphigh, setc_temphigh] = useState(0);
  const [c_vollow, setc_vollow] = useState(0);
  const [c_volhigh, setc_volhigh] = useState(0);
  const [c_currlow, setc_currlow] = useState(0);
  const [c_currentHigh, setc_currentHigh] = useState(0);
  const [intervalValue, setIntervalValue] = useState("1");
  const [intervalType, setIntervalType] = useState("day");
  const [o_time_on, seto_time_on] = useState(0);
  const [o_delay_after_on, seto_delay_after_on] = useState(0);
  const [o_ph_active_time, seto_ph_active_time] = useState(0);
  const [o_start_active_on, seto_start_active_on] = useState(0);
  const [o_dosing_gpio, seto_dosing_gpio] = useState(0);
  const [o_chlorine_pump_time, seto_chlorine_pump_time] = useState(0);
  const [o_pump_enable, seto_pump_enable] = useState("");

  const [chl_time_on, setchl_time_on] = useState(0);
  const [chl_delay_after_on, setchl_delay_after_on] = useState(0);
  const [chl_ph_active_time, setchl_ph_active_time] = useState(0);
  const [chl_start_active_on, setchl_start_active_on] = useState(0);
  const [chl_dosing_gpio, setchl_dosing_gpio] = useState(0);
  const [chl_chlorine_pump_time, setchl_chlorine_pump_time] = useState(0);
  const [chl_alum_gpio, setchl_alum_gpio] = useState(0);
  const [chl_pump_enable, setchl_pump_enable] = useState("");

  const [activemode, setactivemode] = useState("");
  const [o_alum_gpio, seto_alum_gpio] = useState(0);
  const [rs485, setrs485] = useState("");
  const [dosing, setdosing] = useState("");
  const [rs4852, setrs4852] = useState("");
  const [copper, setcopper] = useState("");
  const [dosing2, setdosing2] = useState("");
  const [bypass_mode, setbypass_mode] = useState("");
  const [chl_cu, setchl_cu] = useState("");
  const [sandfilter, setsandfilter] = useState("");
  const [time_on, settime_on] = useState(0);
  const [bypass_measure_interval_min, setbypass_measure_interval_min] =
    useState(0);
  const [bypass_fill_duration_sec, setbypass_fill_duration_sec] = useState(0);
  const [bypass_flush_duration_sec, setbypass_flush_duration_sec] = useState(0);
  const [bypass_push_duration_min, setbypass_push_duration_min] = useState(0);
  const [bypass_sensor_select, setbypass_sensor_select] = useState(0);
  const [bypass_acid_chlorine_delay_min, setbypass_acid_chlorine_delay_min] =
    useState(0);
  const [bypass_current_state, setbypass_current_state] = useState(0);
  const [bypass_last_acid_timestamp, setbypass_last_acid_timestamp] =
    useState("0");
  const [bypass_last_chlorine_timestamp, setbypass_last_chlorine_timestamp] =
    useState("0");
  const [delay_after_on, setdelay_after_on] = useState(0);
  const [ph_active_time, setph_active_time] = useState(0);
  const [start_active_on, setstart_active_on] = useState(0);
  const [dosing_gpio, setdosing_gpio] = useState(0);
  const [chlorine_pump_time, setchlorine_pump_time] = useState(0);
  const [alum_gpio, setalum_gpio] = useState(0);
  const [pump_enable, setpump_enable] = useState("");
  const [move_2, setmove_2] = useState("");
  const [move_station, setmove_station] = useState("");
  const [move_pwm, setmove_pwm] = useState("");
  const [stop, setstop] = useState("");
  const [read, setread] = useState("");
  const [info, setinfo] = useState("");
  const [status, setstatus] = useState("");
  const [ble_name, setble_name] = useState("");
  const [sand_filter_mac, setsand_filter_mac] = useState("");
  const [voltage_offset, setvoltage_offset] = useState("");
  const [current_offset, setCurrentOffset] = useState("");

  const [rs485command, setrs485command] = useState("");
  // const [selectedLabel, setSelected] = useState("");
  const [currentRole, setCurrentRole] = useState("");
  const [isCalibrated, setIsCalibrated] = useState(false);
  const [calibrationMode, setCalibrationMode] = useState("");

  const [isCalibrated2, setIsCalibrated2] = useState(false);
  const [calibrationMode2, setCalibrationMode2] = useState("");
  useEffect(() => {
    const role = location.state?.role || localStorage.getItem("role");

    if (!role) {
      navigate("/dashboard");
    } else {
      setCurrentRole(role);
    }
    // eslint-disable-next-line
  }, [location]);
  const { subscribe, publish } = useContext(MqttContext);
  useEffect(() => {
    if (!mac) return;
    subscribe(`sandfilter/sensor/${sand_filter_mac?.replaceAll(":", "")}`);
    subscribe(`sandfilter/sensor/${mac?.replaceAll(":", "")}`);
    // eslint-disable-next-line
  }, [mac]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    if (isDirty) {
      //console.log("Skipped auto refresh due to unsaved changes");
      return;
    }
    const fetchData = async () => {
      try {
        const response3 = await fetch(
          `${API_URL}/getthreshold.php?getdata=${mac}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const json3 = await response3.json();
        setThreshold(json3);
        setname(json3?.name);
        setrs485(json3?.rs485);
        setdosing(json3?.dosing);
        setrs4852(json3?.rs4852);
        setdosing2(json3?.dosing2);
        setbypass_mode(json3?.bypass_mode);
        setchl_cu(json3?.chl_cu);
        setsandfilter(json3?.sand_filter);
        setmove_station(json3?.run_station?.split(",")[0]);
        setmove_pwm(json3?.run_station?.split(",")[1]);
        setmove_2(json3?.run_station?.split(",")[2]);
        setstop(json3?.stop);
        setread(json3?.read_command);
        setinfo(json3?.info);
        setstatus(json3?.status);
        setble_name(json3?.ble_name);
        setrs485command(json3?.rs485_command);
        setAcid_pump_time(json3?.Acid_pump_current);
        setChlorine_pump_time(json3?.Chlorine_pump_current);
        setOther_pump_time(json3?.Other_pump_current);
        setPumpMode1(json3?.acid_pump);
        setPumpMode2(json3?.chlorine_pump);
        setPumpMode3(json3?.other_pump);
        setloading(false);
        setLoadRegister2(json3?.load_register);
        setEnable(json3?.enable);
        setCellular(json3?.cellular_mode);
        setAPN(json3?.apn || "internet");

        setsandFilterData(json3?.sand_filter_settings);
        setCircPump(json3?.circ_pump);
        setCircCurrent(json3?.circ_current);
        setCircThreshold(json3?.circ_threshold);
        setMac(json3?.sand_filter_mac);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [mac]);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_URL}/getthreshold.php?getdata=${message}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      //  console.log("API response:", responseData);

      setSelectedCardIndex(
        responseData?.rs485 === "true"
          ? 0
          : responseData?.rs4852 === "true" || responseData?.copper === "true"
          ? 1
          : responseData?.dosing === "true" ||
            responseData?.dosing2 === "true" ||
            responseData?.chl_cu === "true"
          ? 2
          : responseData?.bypass_mode === "bypass_mode"
          ? 3
          : 4
      );

      setphlow(parseFloat(responseData?.pHLow) || 0.0);
      setphhigh(parseFloat(responseData?.pHHigh) || 0.0);
      setorplow(parseFloat(responseData?.ORPLow) || 0.0);
      setorphigh(parseFloat(responseData?.ORPHigh) || 0.0);
      setdolow(parseFloat(responseData?.DOLow) || 0.0);
      setdohigh(parseFloat(responseData?.DOHigh) || 0.0);
      settemplow(parseFloat(responseData?.temperatureLow) || 0.0);
      settemphigh(parseFloat(responseData?.temperatureHigh) || 0.0);
      setvollow(parseFloat(responseData?.voltageLow) || 0.0);
      setvolhigh(parseFloat(responseData?.voltageHigh) || 0.0);
      setcurrlow(parseFloat(responseData?.currentLow) || 0.0);
      setcurrentHigh(parseFloat(responseData?.currentHigh) || 0.0);
      setc_phlow(parseFloat(responseData?.c_pHLow) || 0.0);
      setc_phhigh(parseFloat(responseData?.c_pHHigh) || 0.0);
      setc_orplow(parseFloat(responseData?.c_ORPLow) || 0.0);
      setc_orphigh(parseFloat(responseData?.c_ORPHigh) || 0.0);
      setc_dolow(parseFloat(responseData?.c_DOLow) || 0.0);
      setc_dohigh(parseFloat(responseData?.c_DOHigh) || 0.0);
      setc_templow(parseFloat(responseData?.c_temperatureLow) || 0.0);
      setc_temphigh(parseFloat(responseData?.c_temperatureHigh) || 0.0);
      setc_vollow(parseFloat(responseData?.c_voltageLow) || 0.0);
      setc_volhigh(parseFloat(responseData?.c_voltageHigh) || 0.0);
      setc_currlow(parseFloat(responseData?.c_currentLow) || 0.0);
      setc_currentHigh(parseFloat(responseData?.c_currentHigh) || 0.0);
      setname(responseData?.name);
      setrs485(responseData?.rs485);
      setvoltage_offset(responseData?.voltage_offset);
      setCurrentOffset(responseData?.current_offset || 0);
      setPumpMode1(responseData?.acid_pump);
      setPumpMode2(responseData?.chlorine_pump);
      setPumpMode3(responseData?.other_pump);
      setdosing(responseData?.dosing);
      setrs4852(responseData?.rs4852);
      setcopper(responseData?.copper);
      setdosing2(responseData?.dosing2);
      setbypass_mode(responseData?.bypass_mode);
      setchl_cu(responseData?.chl_cu);
      setsandfilter(responseData?.sand_filter);
      settime_on(parseInt(responseData?.time_on) || 0);
      setdelay_after_on(parseInt(responseData?.delay_after_on) / 60 || 0);
      setph_active_time(
        responseData?.ph_active_time?.includes("m³")
          ? responseData?.ph_active_time
          : parseInt(responseData?.ph_active_time) || 0
      );
      setstart_active_on(parseFloat(responseData?.start_active_on) || 0.0);
      setdosing_gpio(parseFloat(responseData?.dosign_acid_current_gpio) || 0.0);
      setchlorine_pump_time(
        parseFloat(responseData?.chlorine_pump_time) || 0.0
      );
      setCalibrationMode2(responseData?.chl_calibration_type);
      setCalibrationMode(responseData?.ph_calibration_type);
      setLoadRegister(responseData?.load_r);
      setIsCalibrated2(responseData?.chl_calibration === "true");
      setIsCalibrated(responseData?.ph_calibration === "true");
      setAcid_pump_time(responseData?.Acid_pump_current);
      setChlorine_pump_time(responseData?.Chlorine_pump_current);
      setOther_pump_time(responseData?.Other_pump_current);
      setalum_gpio(parseFloat(responseData?.alum_current_gpio) || 0.0);
      seto_time_on(
        responseData?.o_time_on === "1day" ||
          responseData?.o_time_on === "1week" ||
          responseData?.o_time_on === "2week" ||
          responseData?.o_time_on === "3week" ||
          responseData?.o_time_on === "4week"
          ? responseData?.o_time_on
          : parseInt(responseData?.o_time_on) || 0
      );

      if (responseData?.o_delay_after_on) {
        seto_delay_after_on(responseData?.o_delay_after_on);
        const match = responseData?.o_delay_after_on.match(/(\d+)(day|week)/);
        if (match) {
          setIntervalValue(match[1]);
          setIntervalType(match[2]);
        }
      }
      seto_ph_active_time(parseInt(responseData?.o_ph_active_time) || 0);
      seto_start_active_on(parseFloat(responseData?.o_start_active_on) || 0.0);
      setsand_filter_mac(responseData?.sand_filter_mac);
      seto_dosing_gpio(
        parseFloat(responseData?.o_dosign_acid_current_gpio) || 0.0
      );
      seto_chlorine_pump_time(
        parseFloat(responseData?.o_chlorine_pump_time) || 0.0
      );
      seto_alum_gpio(parseFloat(responseData?.o_alum_current_gpio) || 0.0);

      setchl_time_on(parseInt(responseData?.chl_time_on) || 0);

      setbypass_measure_interval_min(
        parseInt(responseData?.bypass_measure_interval_min) || 10
      );
      setbypass_fill_duration_sec(
        parseInt(responseData?.bypass_fill_duration_sec) || 2
      );
      setbypass_flush_duration_sec(
        parseInt(responseData?.bypass_flush_duration_sec) || 5
      );
      setbypass_push_duration_min(
        parseInt(responseData?.bypass_push_duration_min) || 10
      );
      setbypass_sensor_select(
        parseInt(responseData?.bypass_sensor_select) || 1
      );
      setbypass_acid_chlorine_delay_min(
        parseInt(responseData?.bypass_acid_chlorine_delay_min) || 30
      );
      setbypass_current_state(
        parseInt(responseData?.bypass_current_state) || 0
      );
      setbypass_last_acid_timestamp(
        responseData?.bypass_last_acid_timestamp || "0"
      );
      setbypass_last_chlorine_timestamp(
        responseData?.bypass_last_chlorine_timestamp || "0"
      );

      setchl_delay_after_on(
        parseInt(responseData?.chl_delay_after_on) / 60 || 0
      );
      // setchl_ph_active_time(parseInt(responseData?.chl_ph_active_time) || 0);
      setchl_ph_active_time(
        responseData?.chl_ph_active_time?.includes("m³")
          ? responseData?.chl_ph_active_time
          : parseInt(responseData?.chl_ph_active_time) || 0
      );

      setchl_start_active_on(
        parseFloat(responseData?.chl_start_active_on) || 0.0
      );
      setchl_dosing_gpio(
        parseFloat(responseData?.chl_dosign_acid_current_gpio) || 0.0
      );
      setchl_chlorine_pump_time(
        parseFloat(responseData?.chl_chlorine_pump_time) || 0.0
      );
      setchl_alum_gpio(parseFloat(responseData?.chl_alum_current_gpio) || 0.0);

      setpump_enable(responseData?.pump_enable || "");
      seto_pump_enable(responseData?.o_pump_enable || "");
      setchl_pump_enable(responseData?.chl_pump_enable || "");
      setmove_station(responseData?.run_station?.split(",")[0]);
      setmove_pwm(responseData?.run_station?.split(",")[1]);
      setmove_2(responseData?.run_station?.split(",")[2]);
      setstop(responseData?.stop);
      setread(responseData?.read_command);
      setinfo(responseData?.info);
      setstatus(responseData?.status);
      setble_name(responseData?.ble_name);
      setrs485command(responseData?.rs485_command);

      // Set activemode
      if (
        responseData.activemode !== undefined &&
        responseData.activemode !== null
      ) {
        setactivemode(responseData.activemode.toString());
      }

      setloading2(false);
    } catch (error) {
      console.error("Error fetching threshold data:", error);
      setloading2(false);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [message]);

  useEffect(() => {
    if (!activemode) return;

    const mode = activemode.toString();

    const index =
      mode === "1"
        ? 0
        : mode === "2"
        ? 1
        : mode === "3"
        ? 2
        : mode === "4"
        ? 3
        : mode === "5"
        ? 4
        : mode === "6"
        ? 5
        : null;

    setSelectedIndex(index);
  }, [activemode]);

  useEffect(() => {
    const enabledAt = localStorage.getItem("calibrationEnabledAt");
    if (enabledAt) {
      const elapsed = Date.now() - parseInt(enabledAt);
      const remaining = 20000 - elapsed;

      if (remaining > 0) {
        setIsCalibrated(true);
        const timer = setTimeout(() => {
          fetch(`${API_URL}/settings.php`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ph_mac: message || "",
              ph_calibration: "false",
            }),
          })
            .then((response) => response.json())
            .then((responseData) => {
              // console.log(responseData, "auto-disabled after reload");
              setIsCalibrated(false);
              localStorage.removeItem("calibrationEnabledAt");
            })
            .catch((err) => console.log(err));
        }, remaining);

        return () => clearTimeout(timer);
      } else {
        // Timer already expired
        localStorage.removeItem("calibrationEnabledAt");
        setIsCalibrated(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sendReadCommand = async (read, stop) => {
    fetch(`${API_URL}/settings.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        read_mac: message || "",
        read: read || "",
        stop: stop || "",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        alert("Settings Updated");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sendthreshold = async () => {
    fetch(`${API_URL}/getthreshold.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pHHigh: phhigh || "",
        pHLow: phlow || "",
        ORPHigh: orphigh || "",
        ORPLow: orplow || "",
        DOHigh: dohigh || "",
        DOLow: dolow || "",
        temperatureHigh: temphigh || "",
        temperatureLow: templow || "",
        voltageHigh: volhigh || "",
        voltageLow: vollow || "",
        currentHigh: currentHigh || "",
        currentLow: currlow || "",
        c_pHHigh: c_phhigh || "",
        c_pHLow: c_phlow || "",
        c_ORPHigh: c_orphigh || "",
        c_ORPLow: c_orplow || "",
        c_DOHigh: c_dohigh || "",
        c_DOLow: c_dolow || "",
        c_temperatureHigh: c_temphigh || "",
        c_temperatureLow: c_templow || "",
        c_voltageHigh: c_volhigh || "",
        c_voltageLow: c_vollow || "",
        c_currentHigh: c_currentHigh || "",
        c_currentLow: c_currlow || "",
        mac: message || "",
        name: name || "",
        time_on: time_on || "",
        delay_after_on: parseInt(delay_after_on || "0") * 60 || "",
        ph_active_time: ph_active_time || "",
        start_active_on: start_active_on || "",
        dosign_acid_current_gpio: dosing_gpio || "",
        chlorine_pump_time: chlorine_pump_time || "",
        alum_current_gpio: alum_gpio || "",
        pump_enable: pump_enable || "",

        run_station: [move_station, move_pwm, move_2].filter(Boolean).join(","),
        o_time_on: o_time_on || "",
        o_delay_after_on: o_delay_after_on || "",
        o_ph_active_time: o_ph_active_time || "",
        o_start_active_on: o_start_active_on || "",
        o_dosign_acid_current_gpio: o_dosing_gpio || "",
        o_chlorine_pump_time: o_chlorine_pump_time || "",
        o_alum_current_gpio: o_alum_gpio || "",
        o_pump_enable: o_pump_enable || "",

        chl_time_on: chl_time_on || "",
        chl_delay_after_on: parseInt(chl_delay_after_on || "0") * 60 || "",
        chl_ph_active_time: chl_ph_active_time || "",
        chl_start_active_on: chl_start_active_on || "",

        bypass_measure_interval_min: bypass_measure_interval_min || "",
        bypass_fill_duration_sec: bypass_fill_duration_sec || "",
        bypass_flush_duration_sec: bypass_flush_duration_sec || "",
        bypass_push_duration_min: bypass_push_duration_min || "",
        bypass_sensor_select: bypass_sensor_select || "",
        bypass_acid_chlorine_delay_min: bypass_acid_chlorine_delay_min || "",
        bypass_current_state: bypass_current_state || "",
        chl_dosign_acid_current_gpio: chl_dosing_gpio || "",
        chl_chlorine_pump_time: chl_chlorine_pump_time || "",
        chl_alum_current_gpio: chl_alum_gpio || "",
        chl_pump_enable: chl_pump_enable || "",

        stop: stop?.toString() === "true" ? "false" : "true" || "",
        read_command: read?.toString() === "true" ? "false" : "true" || "",
        info: info?.toString() || "",
        activemode: activemode || "",
        status: status?.toString() || "",
        ble_name: ble_name || "",
        rs485_command: rs485command?.toString() || "",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        alert("Settings Updated");
        fetchData();
      })
      .catch((err) => {
        console.log(err);
      });
    setIsDirty(false);
  };
  const [selected, setSelectedIndex] = useState(null); // default value
  useEffect(() => {
    const index =
      activemode === "1"
        ? 0
        : activemode === "2"
        ? 1
        : activemode === "3"
        ? 2
        : activemode === "4"
        ? 3
        : activemode === "5"
        ? 4
        : activemode === "6"
        ? 5
        : null;

    setSelectedIndex(index);
  }, [activemode]);

  const publishdata = (command) => {
    publish(
      `sandfilter/settings/${sand_filter_mac?.replaceAll(":", "")}`,
      command,
      { qos: 1 }
    );
    publish(`sandfilter/settings/${mac?.replaceAll(":", "")}`, command, {
      qos: 1,
    });
  };
  const publishdata2 = (command) => {
    publish(`dssp/settings/${mac?.trim()}`, command, { qos: 1 });
  };

  const [isDirty, setIsDirty] = useState(false);
  useEffect(() => {
    //console.log("Selected index in SandFilterWheel (updated):", selected);
  }, [selected]);

  //
  const [selectedCardIndex, setSelectedCardIndex] = useState(
    rs485 === "true"
      ? 0
      : rs4852 === "true" || copper === "true"
      ? 1
      : dosing === "true" || dosing2 === "true" || chl_cu === "true"
      ? 2
      : bypass_mode === "true"
      ? 3
      : 4
  );

  // Segments with dynamic values
  const segments = [
    {
      label: "FILTER",
      value: move_station,
      image: require("../img/record.png"),
      angle: 270,
      color: "#8ec5fc",
    },
    {
      label: "CLOSED",
      value: move_pwm,
      image: require("../img/close.png"),
      angle: 330,
      color: "#8ec5fc",
    },
    {
      label: "RECIRCU",
      value: stop,
      image: require("../img/reload.png"),
      angle: 30,
      color: "#8ec5fc",
    },
    {
      label: "BACKWASH",
      value: read,
      image: require("../img/water-drop.png"),
      angle: 90,
      color: "#8ec5fc",
    },
    {
      label: "QDCW",
      value: info,
      image: require("../img/water.png"),
      angle: 150,
      color: "#8ec5fc",
    },
    {
      label: "WASTE",
      value: ble_name,
      image: require("../img/waste-water.png"),
      angle: 210,
      color: "#8ec5fc",
    },
  ];

  const radius = 160;
  const center = radius;
  const total = segments.length;
  const angle = 360 / total;
  const API_BASE = `${API_URL}/settings.php`; // 🔹 Replace with real API
  const API_BASE2 = `${API_URL}/getthreshold.php?getdata=${mac}`; // 🔹 Replace with real API

  const polarToCartesian = (r, angleInDegrees) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
      x: r * Math.cos(angleInRadians),
      y: r * Math.sin(angleInRadians),
    };
  };
  const [selectedMode, setSelectedMode] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modeSettings, setModeSettings] = useState({});

  const [station, setStation] = useState("");
  const [pwm, setPwm] = useState("");
  const [timer, setTimer] = useState("");
  const saveModeData = async () => {
    try {
      const updatedSettings = {
        ...modeSettings,
        [selectedMode]: {
          station,
          pwm,
          timer,
        },
      };
      if (selectedMode === "FILTER") {
        if ((parseInt(timer) >= 8 && parseInt(timer) <= 12) || timer === "") {
        } else {
          alert("Not less than 8 hr or greter than 12 hr");
          return;
        }
      }
      if (selectedMode === "BACKWASH") {
        if ((parseInt(timer) >= 2 && parseInt(timer) <= 3) || timer === "") {
        } else {
          alert("Not less than 3 min or greter than 30 min");
          return;
        }
      }
      if (selectedMode === "QDCW") {
        if ((parseInt(timer) >= 30 && parseInt(timer) <= 60) || timer === "") {
        } else {
          alert("Not less than 30 sec or greter than 60 sec");
          return;
        }
      }

      // Prevent saving same station for another mode
      const duplicateMode = Object.entries(updatedSettings).find(
        ([modeKey, values]) =>
          modeKey !== selectedMode && values.station === station
      );
      if (parseInt(station) === 0) {
        alert(`Station value should not be 0`);
        return;
      }
      if (duplicateMode) {
        alert(
          `Station ${station} is already used in mode "${duplicateMode[0]}". Please choose another.`
        );
        return;
      }

      setModeSettings(updatedSettings);
      const payload = {
        sandfilter_setting_mac: sand_filter_mac || mac, // e.g. "00:1B:44:11:3A:B7"
        sandfilter_setting: JSON.stringify(updatedSettings), // your JSON object
      };
      const res = await fetch(`${API_BASE}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      await res.json();
      setModalOpen(false);
    } catch (err) {
      console.error("Save error:", err);
    }
  };
  const fetchAllModes = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE2}`);
      if (res.data && res.data !== "No data") {
        // ensure we have an object
        setModeSettings(JSON.parse(res.data.sand_filter_settings) || {});
      } else {
        setModeSettings({});
      }
    } catch (err) {
      console.error("LOAD ERROR:", err);
      setModeSettings({});
    }
    // eslint-disable-next-line
  }, []);
  const [loadRegister, setLoadRegister] = useState(null);
  const [loadRegister2, setLoadRegister2] = useState(null);
  const [enable, setEnable] = useState("");
  const [cellular, setCellular] = useState("");
  const [sandFilterData, setsandFilterData] = useState("");
  const [CircPump, setCircPump] = useState("");
  const [CircCurrent, setCircCurrent] = useState("");
  const [CircThreshold, setCircThreshold] = useState("");
  const [Mac, setMac] = useState("");
  const [APN, setAPN] = useState("");

  useEffect(() => {
    const enabledAt = localStorage.getItem("calibrationEnabledAt2");
    if (enabledAt) {
      const elapsed = Date.now() - parseInt(enabledAt);
      const remaining = 20000 - elapsed;

      if (remaining > 0) {
        setIsCalibrated2(true);
        const timer = setTimeout(() => {
          fetch(`${API_URL}/settings.php`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ph_mac: message || "",
              ph_calibration: "false",
            }),
          })
            .then((response) => response.json())
            .then((responseData) => {
              //  console.log(responseData, "auto-disabled after reload");
              setIsCalibrated2(false);
              localStorage.removeItem("calibrationEnabledAt2");
            })
            .catch((err) => console.log(err));
        }, remaining);

        return () => clearTimeout(timer);
      } else {
        // Timer already expired
        localStorage.removeItem("calibrationEnabledAt2");
        setIsCalibrated2(false);
      }
    }
    // eslint-disable-next-line
  }, []);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const containerRef1 = useRef(null);
  const containerRef2 = useRef(null);
  const findClosestIndex = (value) => {
    const numVal = parseFloat(value);
    if (isNaN(numVal)) return -1;

    // Find closest value in pool_size
    let closestIndex = 0;
    let smallestDiff = Math.abs(numVal - parseFloat(pool_size[0]));

    for (let i = 1; i < pool_size.length; i++) {
      const diff = Math.abs(numVal - parseFloat(pool_size[i]));
      if (diff < smallestDiff) {
        smallestDiff = diff;
        closestIndex = i;
      }
    }
    return closestIndex;
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setph_active_time(val);
    setIsDirty(true);

    const idx = findClosestIndex(val);
    if (idx !== -1) {
      settime_on(acid_pump_time[idx]);
      setdelay_after_on(acid_impact_time[idx]);
    } else {
      settime_on("");
      setdelay_after_on("");
    }
  };

  const handleChange2 = (e) => {
    const val = e.target.value;
    setph_active_time(val);
    setIsDirty(true);

    const idx = findClosestIndex(val);
    if (idx !== -1) {
      setchl_time_on(pump_time[idx]);
      setchl_delay_after_on(impact_time[idx]);
    } else {
      setchl_time_on("");
      setchl_delay_after_on("");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef1.current &&
        !containerRef1.current.contains(event.target)
      ) {
        setOpen(false);
      }
      if (
        containerRef2.current &&
        !containerRef2.current.contains(event.target)
      ) {
        setOpen2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    fetchAllModes();
  }, [fetchAllModes]);
  const selectedSeg = React.useRef(null); // ✅ Track clicked segment

  const SandFilterWheel = () => {
    const getBoxPosition = (i) => {
      const midAngle = (i + 0.5) * angle - 90; // rotate so 0 is top
      const rad = (midAngle * Math.PI) / 180;
      const distance = radius + 60; // distance from center to box
      return {
        left: center + distance * Math.cos(rad) + 0,
        top: center + distance * Math.sin(rad) - 80,
      };
    };

    // Save mode data to API
    const handleLongPress = (mode) => {
      setSelectedMode(mode);

      const safeSettings = modeSettings || {}; // fallback
      const modeData = safeSettings[mode] || {}; // fallback
      setStation(modeData.station || "");
      setPwm(modeData.pwm || "");
      setTimer(modeData.timer || "");
      setModalOpen(true);
      selectedSeg.current = null;
    };

    // Handle click
    const handleClick = async (mode) => {
      selectedSeg.current = mode;
      setTimeout(() => {
        handleLongPress(mode);
      }, 500);
    };

    // Handle long press
    let pressTimer;
    const handleMouseDown = (mode) => {
      //   pressTimer = setTimeout(() => handleLongPress(mode), 700);
    };

    const handleMouseUp = () => clearTimeout(pressTimer);

    return (
      <>
        {/* Wheel */}
        <div
          style={{
            position: "fixed", // or "absolute", depending on layout
            top: "50%",
            left: "50%",
            marginTop: isMobile ? "0px" : "0px",
            marginLeft: "1px",
            transform: "translate(-50%, -50%)",
            width: isMobile ? radius : 2 * radius,
            height: radius,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "0px",
          }}
        >
          <svg
            width={isMobile ? radius : 2 * radius}
            height={2 * radius}
            viewBox={`0 0 ${2 * radius} ${2 * radius}`}
            style={{ overflow: "visible", cursor: "default" }} // Allows space beyond radius
          >
            {segments?.map((seg, i) => {
              const startAngle = i * angle;
              const endAngle = (i + 1) * angle;
              const largeArc = angle > 180 ? 1 : 0;

              const start = polarToCartesian(radius, startAngle);
              const end = polarToCartesian(radius, endAngle);
              const isSelected = seg.label === selectedSeg.current;
              return (
                <g
                  key={i}
                  onMouseDown={() => handleMouseDown(seg.label)}
                  onMouseUp={handleMouseUp}
                  onClick={() => handleClick(seg.label)}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    d={`
                      M ${center} ${center}
                      L ${center + start.x} ${center + start.y}
                      A ${radius} ${radius} 0 ${largeArc} 1 ${center + end.x} ${
                      center + end.y
                    }
                      Z
                    `}
                    fill={isSelected ? seg.color : "#fff"}
                    stroke={isSelected ? "black" : "black"}
                    strokeWidth={isSelected ? 3 : 2}
                    style={
                      //i === selected||
                      isSelected
                        ? {
                            filter: isSelected
                              ? "drop-shadow(2px 2px 8px rgba(0,0,0,0.6))"
                              : "none",
                            transform: "scale(1.02)",
                            transformOrigin: "center",
                            transition: "all 0.3s ease-in-out",
                          }
                        : {
                            transition: "all 0.3s ease-in-out",
                          }
                    }
                  />
                  <image
                    href={seg.image}
                    x={
                      center +
                      0.45 *
                        radius *
                        Math.cos(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        ) -
                      8
                    }
                    y={
                      center +
                      0.45 *
                        radius *
                        Math.sin(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        ) -
                      10
                    }
                    width="20"
                    height="20"
                  />
                  <text
                    x={
                      center +
                      0.6 *
                        radius *
                        Math.cos(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        )
                    }
                    y={
                      center +
                      0.6 *
                        radius *
                        Math.sin(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        ) -
                      10
                    }
                    fontSize="13"
                    fontWeight="600"
                    textAnchor="middle"
                    fill={isSelected ? "black" : "black"}
                    alignmentBaseline="middle"
                    transform={`
                    rotate(${startAngle + angle / 2} ${
                      center +
                      0.6 *
                        radius *
                        Math.cos(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        )
                    } ${
                      center +
                      0.6 *
                        radius *
                        Math.sin(
                          ((startAngle + angle / 2 - 90) * Math.PI) / 180
                        )
                    })`}
                  >
                    {seg.label}
                  </text>
                </g>
              );
            })}
          </svg>
          {localStorage.getItem("role") === "Product Manager"
            ? segments.map((seg, i) => {
                const pos = getBoxPosition(i);
                const modeData = modeSettings?.[seg.label] || {};
                return (
                  <div
                    key={i}
                    style={{
                      position: "absolute",
                      top: pos.top,
                      left: pos.left,
                      transform: "translate(-50%, -50%)",
                      width: 100,
                      background: "#8ec5fc",
                      borderRadius: 8,
                      fontSize: "10px",
                      fontWeight: "400",
                      padding: 6,
                      textAlign: "center",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                  >
                    <div>Station: {modeData.station || "-"}</div>
                    <div>PWM: {modeData.pwm || "-"}</div>
                    {seg.label === "CLOSED" ? null : (
                      <div>
                        Timer: {modeData.timer || "-"}{" "}
                        {seg.label === "FILTER"
                          ? "(hr)"
                          : seg.label === "QDCW"
                          ? "(sec)"
                          : "(min)"}
                      </div>
                    )}
                  </div>
                );
              })
            : null}{" "}
        </div>

        {/* Modal */}
      </>
    );
  };

  return (
    <div style={{ display: "flex", height: "100vh", width: "100%" }}>
      <div>
        {isMobile && (
          <button
            onClick={() => setShowSidebar(!showSidebar)}
            style={{
              position: "fixed",
              top: 10,
              left: 10,
              zIndex: 1000,
              padding: "8px 12px",
              backgroundColor: "#8ec5fc",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            ☰
          </button>
        )}

        {/* Overlay */}

        {isMobile && showSidebar && (
          <div
            onClick={() => setShowSidebar(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.3)", // overlay darkens background
              zIndex: 998,
              pointerEvents: "auto",
            }}
          />
        )}

        {(!isMobile || showSidebar) && <Sidebar />}
      </div>

      <div
        style={{
          flex: 1,
          paddingBottom: "50px",
          overflowX: "hidden",
          height: "100vh", // Allows content to grow beyond viewport
          backgroundColor: "#fff",
          overflowY: "auto", // Enables scrolling if needed
        }}
      >
        <div className="topnav">
          {rs485 === "true" && (
            <button
              onClick={() => setSelectedCardIndex(0)}
              className={selectedCardIndex === 0 ? "active" : "inactive"}
              title="PH/ORP/Temp"
            >
              PH/ORP/Temp
            </button>
          )}

          {(rs4852 === "true" || copper === "true") && (
            <button
              onClick={() => setSelectedCardIndex(1)}
              className={selectedCardIndex === 1 ? "active" : "inactive"}
              title="Chlorine/PH/Temp"
            >
              {rs4852 === "true" ? "Chlorine/PH/Temp" : "Copper/PH/Temp"}
            </button>
          )}

          {(dosing === "true" || dosing2 === "true" || chl_cu === "true") && (
            <button
              onClick={() => setSelectedCardIndex(2)}
              className={selectedCardIndex === 2 ? "active" : "inactive"}
              title="Acid"
            >
              Acid/Others/Chl_Cu
            </button>
          )}
          {bypass_mode === "true" && (
            <button
              onClick={() => setSelectedCardIndex(3)}
              className={selectedCardIndex === 3 ? "active" : "inactive"}
              title="Bypass Mode"
            >
              Bypass Mode
            </button>
          )}
          {sandfilter === "true" && (
            <button
              onClick={() => setSelectedCardIndex(4)}
              className={selectedCardIndex === 4 ? "active" : "inactive"}
              title="Sand Filter"
            >
              Sand Filter
            </button>
          )}
        </div>
        {loading ? (
          <>
            <div
              style={{
                width: "50px",
                height: "50px",
                border: "5px solid #ddd",
                borderTop: "5px solid #8ec5fc", // Change to a theme-based color
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                display: "flex",
                margin: "auto",
                marginTop: "100px",
              }}
            ></div>
            <div
              style={{
                marginTop: "20px",
                fontSize: "100%",
                color: "#489ff6",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Uploading File...
            </div>
            <style>
              {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
            </style>
          </>
        ) : (
          <>
            {loading2 ? (
              <div
                style={{
                  width: "80vw",
                  height: "70vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader message="Please Wait..." />
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100vh",
                  padding: "0px 0",
                }}
              >
                <div
                  id="mainview"
                  style={{
                    width: "100%",
                    minHeight: "10vh",
                    padding: "0",
                    borderRadius: "8px",
                    overflowX: "hidden",
                    overflowY: "hidden", // ✅ Scroll on mobile
                  }}
                >
                  <div className="status-container">
                    <h5 className="status-title">Status</h5>

                    <div className="status-controls">
                      {currentRole !== "User" &&
                        currentRole !== "Site Manager" && (
                          <button
                            className="dummy-button"
                            onClick={() => {
                              if (!mac) return;
                              const url = `${
                                window.location.origin
                              }/dummydata?id=${encodeURIComponent(mac)}`;
                              window.open(url, "_blank", "noopener,noreferrer");
                            }}
                          >
                            Dummy Data
                          </button>
                        )}

                      <div className="name-input-container">
                        <label htmlFor="endDate">Name:</label>
                        <input
                          type="text"
                          id="endDate"
                          name="endDate"
                          value={name}
                          onChange={(e) => {
                            setname(e.target.value);
                            setIsDirty(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      flexWrap: "nowrap",
                      overflowX: "auto",
                      gap: "20px",
                      justifyContent: "center",
                      color: "#000",
                      margin: 20,
                    }}
                  >
                    <div style={{ display: "flex", overflow: "auto" }}>
                      {rs485 === "true" && selectedCardIndex === 0 ? (
                        <div
                          style={{
                            width: "50%",
                          }}
                        >
                          <div
                            className="metric-group-card"
                            style={{
                              // background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                              color: "black",
                              padding: isMobile ? "15px" : "0px",
                              borderRadius: "12px",
                              // boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                              width: "95%",
                              maxWidth: "100%",
                              alignItems: "center",
                              overflow: "hidden", // fixed typo
                              textAlign: "center",
                              fontSize: isMobile ? "14px" : "2.2vh",
                              paddingBottom: "10px",
                            }}
                          >
                            {[
                              {
                                label: "PH",
                                value: threshold?.PH ?? "--",
                                icon: require("../img/ph.png"),
                                filter: "",
                                min: threshold?.pHLow,
                                max: threshold?.pHHigh,
                              },
                              {
                                label: "ORP",
                                value: threshold?.ORP ?? "--",
                                icon: require("../img/orp.png"),
                                filter: "brightness(0) invert(0)",
                                min: threshold?.ORPLow,
                                max: threshold?.ORPHigh,
                              },
                              {
                                label: "Temperature",
                                value: threshold?.Temperature ?? "--",
                                unit: "°C",
                                icon: require("../img/temperature.png"),
                                filter:
                                  "sepia(100) saturate(100) hue-rotate(-50deg) brightness(100.5)",
                                min: threshold?.temperatureLow,
                                max: threshold?.temperatureHigh,
                              },
                            ]
                              .filter((item) => {
                                if (
                                  currentRole === "User" &&
                                  (item.label === "Voltage" ||
                                    item.label === "Current")
                                ) {
                                  return false;
                                }
                                return true;
                              })
                              .map((item, index) => {
                                let tmpvalue = "Normal";
                                const value = parseFloat(item.value);
                                //console.log(value, parseFloat(item.max), parseFloat(item.min),"*^^^^")
                                let bgColor = "rgba(88,220,96,1)";

                                if (!isNaN(value)) {
                                  if (value > parseFloat(item.max)) {
                                    bgColor = "rgb(255,100,100)";
                                    tmpvalue = "High";
                                  } else if (value < parseFloat(item.min)) {
                                    bgColor = "rgba(250,200,0,1)";
                                    tmpvalue = "Low";
                                  }
                                }

                                return (
                                  <div
                                    key={index}
                                    className="metric-card"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      padding: isMobile ? "10px" : "16px",
                                      borderRadius: "2vh",
                                      background: bgColor,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.6)",
                                      border: "0vh solid",
                                      width: "93%",
                                      maxWidth: "100%",
                                      fontSize: isMobile ? "0.95rem" : "2.2vh",
                                      overflow: "hidden",
                                      gap: "10px",
                                      whiteSpace: "nowrap",
                                      minHeight: "11vh",
                                      height: "100%",
                                    }}
                                  >
                                    {/* Left: Label */}
                                    <div
                                      style={{
                                        minWidth: "10.0vw",
                                        textAlign: "left",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {item.label}:
                                    </div>

                                    {/* Center: Value + Unit + Status */}
                                    <div
                                      style={{
                                        flex: 1,
                                        textAlign: "right",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        gap: "6px",
                                      }}
                                    >
                                      <span>{item.value ?? "--"}</span>
                                      <span>{item.unit ?? ""}</span>
                                      <span style={{ opacity: 0.8 }}>
                                        ({tmpvalue})
                                      </span>
                                    </div>

                                    {/* Right: Icon */}
                                    <div
                                      style={{
                                        minWidth: "40px",
                                        textAlign: "right",
                                      }}
                                    >
                                      <img
                                        src={item.icon}
                                        alt={item.label}
                                        style={{
                                          width: isMobile ? "24px" : "5vh",
                                          height: isMobile ? "24px" : "5vh",
                                          filter: item.filter,
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      ) : null}

                      {rs485 === "true" &&
                      selectedCardIndex === 0 &&
                      currentRole !== "User" ? (
                        <div
                          style={{
                            width: isMobile ? "100%" : "calc(100vw - 350px)",
                            minHeight: "60vh",
                            padding: isMobile ? "10px" : "20px",
                            marginLeft: isMobile ? "10px" : "10px", // Fixed: add 'px' to prevent warning
                            marginBottom: "20px",
                            backgroundColor: "#f0f0f0",
                            alignItems: "center",
                            overflowX: "hidden",
                            overflowY: "auto", // ✅ Enable vertical scroll
                            boxSizing: "border-box",
                          }}
                        >
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between", // Spreads left and right
                                // alignItems: isMobile ? "center" : "flex-start",
                                padding: isMobile ? "20px" : "5px",
                                alignItems: "center",
                              }}
                            ></div>
                            <div
                              className=""
                              style={{
                                width: "90%",
                                display: "flex", // Flex container for the row
                                justifyContent: "center", // Add space between the sliders
                                marginTop: "-10px",
                                alignSelf: "center",
                                alignContent: "center",
                                gap: 70,
                              }}
                            >
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  PH Low Threshold: {Number(phlow).toFixed(2)}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={phlow}
                                  min={0.0}
                                  max={14.0}
                                  step={0.1}
                                  onChange={(e) => {
                                    setphlow(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // ✅ Removes space beneath the slider
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0", // ✅ Removes internal spacing
                                    marginTop: "0", // ✅ Prevents vertical gap
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    0.0
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    14.0
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  PH High Threshold: {Number(phhigh).toFixed(2)}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={phhigh}
                                  min={0.0}
                                  max={14.0}
                                  step={0.1}
                                  onChange={(e) => {
                                    setphhigh(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // ✅ Remove space below the slider
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0", // ✅ No extra padding
                                    marginTop: "0", // ✅ No extra margin
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    0.0
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    14.0
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className=""
                              style={{
                                width: "90%",
                                display: "flex", // Flex container for the row
                                justifyContent: "center", // Add space between the sliders
                                marginTop: "0px",
                                alignSelf: "center",
                                alignContent: "center",
                                gap: 70,
                              }}
                            >
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  ORP Low Threshold: {orplow}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={orplow}
                                  min={-300}
                                  max={700}
                                  step={1}
                                  onChange={(e) => {
                                    setorplow(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // ✅ Removes space beneath the slider
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0", // ✅ Removes internal spacing
                                    marginTop: "0", // ✅ Prevents vertical gap
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    -300
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    700
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  ORP High Threshold: {orphigh}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={orphigh}
                                  min={-300}
                                  max={700}
                                  step={1}
                                  onChange={(e) => {
                                    setorphigh(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // ✅ Remove space below the slider
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0", // ✅ No extra padding
                                    marginTop: "0", // ✅ No extra margin
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    -300
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    700
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className=""
                              style={{
                                width: "90%",
                                display: "flex", // Flex container for the row
                                justifyContent: "center", // Add space between the sliders
                                marginBottom: "0px",
                                alignSelf: "center",
                                alignContent: "center",
                                gap: 70,
                              }}
                            ></div>
                            <div
                              className=""
                              style={{
                                width: "90%",
                                display: "flex", // Flex container for the row
                                justifyContent: "center", // Add space between the sliders
                                marginBottom: "0px",
                                alignSelf: "center",
                                alignContent: "center",
                                gap: 70,
                              }}
                            >
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  Temp Low Threshold:{" "}
                                  {Number(templow).toFixed(2)}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={templow}
                                  min={0.0}
                                  max={70.0}
                                  step={0.1}
                                  onChange={(e) => {
                                    settemplow(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // 🛠 Removes space below the slider
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0",
                                    marginTop: "0", // 🛠 Removes space above the labels
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    0.0
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    70.0
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "40%" }}>
                                <div
                                  style={{ color: "#555", fontSize: "2.5vh" }}
                                >
                                  Temp High Threshold:{" "}
                                  {Number(temphigh).toFixed(2)}
                                </div>

                                <input
                                  type="range"
                                  id="myRange"
                                  value={temphigh}
                                  min={0.0}
                                  max={70.0}
                                  step={0.1}
                                  onChange={(e) => {
                                    settemphigh(e.target.value);
                                    setIsDirty(true);
                                  }}
                                  style={{
                                    width: "100%",
                                    background: "#fdfdfd",
                                    accentColor: "#8ec5fc",
                                    marginBottom: "0", // ✅ Removes space between slider and labels
                                    padding: "0",
                                    display: "block",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "70%",
                                    padding: "0", // ✅ Remove any default padding
                                    marginTop: "0", // ✅ Ensure no gap from top
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    0.0
                                  </div>
                                  <div
                                    style={{
                                      color: "#000",
                                      fontSize: "2.5vh",
                                      margin: "0",
                                      padding: "0",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    70.0
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "92%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "20px",
                                margin: "10px auto",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  padding: "0px 0px",
                                  borderRadius: "10px",
                                }}
                              >
                                <div
                                  style={{ fontSize: "3.5vh", color: "#555" }}
                                >
                                  Calibration{" "}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "40px",
                                  marginTop: "0px",
                                  flexDirection: "row",
                                  alignSelf: "flex-start",
                                  width: "27%",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "2.5vh",
                                    color: "#555",
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {" "}
                                  <input
                                    type="radio"
                                    name="calibrationMode"
                                    value="4"
                                    checked={calibrationMode === "4"}
                                    onChange={(e) => {
                                      setCalibrationMode(e.target.value);

                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          ph_type_mac: message || "",
                                          ph_calibration_type: "4" || "",
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => {
                                          console.log(err);
                                        });
                                    }}
                                    style={{
                                      marginRight: "8px",
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                  4
                                </label>
                                {/* </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "40px",
                                  marginTop: "0px",
                                  flexDirection: "row",
                                  width: "90%",
                                }}
                              > */}
                                <label
                                  style={{
                                    fontSize: "2.5vh",
                                    color: "#555",
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="calibrationMode"
                                    value="7"
                                    checked={calibrationMode === "7"}
                                    onChange={(e) => {
                                      setCalibrationMode(e.target.value);
                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          ph_type_mac: message || "",
                                          ph_calibration_type: "7" || "",
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => {
                                          console.log(err);
                                        });
                                    }}
                                    style={{
                                      marginRight: "8px",
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                  7
                                </label>
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  padding: "0px 0px",
                                  borderRadius: "10px",
                                }}
                              >
                                <div
                                  style={{ fontSize: "2.5vh", color: "#555" }}
                                >
                                  Enable/Disable{" "}
                                </div>

                                {/* Toggle Switch */}
                                <label
                                  style={{
                                    position: "relative",
                                    display: "inline-block",
                                    width: "50px",
                                    height: "28px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={isCalibrated}
                                    onChange={(e) => {
                                      setIsCalibrated(e.target.checked);
                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          ph_mac: message || "",
                                          ph_calibration: e.target.checked
                                            ? "true"
                                            : "false",
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => {
                                          console.log(err);
                                        });
                                      if (e.target.checked) {
                                        localStorage.setItem(
                                          "calibrationEnabledAt",
                                          Date.now().toString()
                                        );
                                        setTimeout(() => {
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              ph_mac: message || "",
                                              ph_calibration: "false",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {
                                              setIsCalibrated(false);
                                            })
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }, 20000);
                                      } else {
                                        localStorage.removeItem(
                                          "calibrationEnabledAt"
                                        );
                                      }
                                    }}
                                    style={{ opacity: 0, width: 0, height: 0 }}
                                  />
                                  <span
                                    style={{
                                      position: "absolute",
                                      cursor: "pointer",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: isCalibrated
                                        ? "#8ec5fc"
                                        : "#ccc",
                                      transition: ".4s",
                                      borderRadius: "34px",
                                    }}
                                  ></span>
                                  <span
                                    style={{
                                      position: "absolute",
                                      content: '""',
                                      height: "22px",
                                      width: "22px",
                                      left: isCalibrated ? "26px" : "4px",
                                      bottom: "3px",
                                      backgroundColor: "white",
                                      transition: ".4s",
                                      borderRadius: "50%",
                                    }}
                                  ></span>
                                </label>
                              </div>
                              {/* Row 2: Radio Buttons */}
                            </div>
                          </>{" "}
                        </div>
                      ) : null}
                    </div>
                    {/* 2 */}
                    <div style={{ display: "flex" }}>
                      {selectedCardIndex === 1 ? (
                        <div
                          style={{
                            width: "50%",
                          }}
                        >
                          <div
                            className="metric-group-card"
                            style={{
                              // background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                              color: "black",
                              padding: isMobile ? "15px" : "0px",
                              borderRadius: "12px",
                              // boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                              width: "95%",
                              maxWidth: "100%",
                              alignItems: "center",
                              overflow: "hidden", // fixed typo
                              textAlign: "center",
                              fontSize: isMobile ? "14px" : "2.2vh",
                              paddingBottom: "10px",
                            }}
                          >
                            {[
                              ...(rs4852 === "true"
                                ? [
                                    {
                                      label: "PH",
                                      value: threshold?.c_PH ?? "--",
                                      icon: require("../img/ph.png"),
                                      min: threshold?.c_pHLow,
                                      max: threshold?.c_pHHigh,
                                    },
                                  ]
                                : []),
                              ...(rs4852 === "true"
                                ? [
                                    {
                                      label: "Temperature",
                                      value: threshold?.c_Temperature ?? "--",
                                      unit: "°C",
                                      icon: require("../img/temperature.png"),
                                      min: threshold?.c_temperatureLow,
                                      max: threshold?.c_temperatureHigh,
                                    },
                                  ]
                                : []),
                              ...(rs4852 === "true"
                                ? [
                                    {
                                      label: "Free Chlorine",
                                      value: threshold?.Chlorine ?? "--",
                                      icon: require("../img/chlorine.png"),
                                      min: threshold?.c_DOLow,
                                      max: threshold?.c_DOHigh,
                                    },
                                  ]
                                : []),
                              ...(rs4852 !== "true"
                                ? [
                                    {
                                      label: "Voltage",
                                      value: threshold?.Voltage
                                        ? parseFloat(
                                            threshold?.Voltage
                                          ).toFixed(2)
                                        : "--",
                                      icon: require("../img/volt.png"),
                                      filter: "",
                                      min: threshold?.voltageLow,
                                      max: threshold?.voltageHigh,
                                    },
                                  ]
                                : []),

                              ...(rs4852 !== "true"
                                ? [
                                    {
                                      label: "Current",
                                      value: threshold?.Current
                                        ? parseFloat(
                                            threshold?.Current
                                          ).toFixed(2)
                                        : "--",
                                      icon: require("../img/ampere.png"),
                                      filter: "",
                                      min: threshold?.currentLow,
                                      max: threshold?.currentHigh,
                                    },
                                  ]
                                : []),
                            ].map((item, index) => {
                              let tmpvalue = "Normal";
                              const value = parseFloat(item.value);
                              let bgColor = "rgba(88,220,96,1)";

                              if (!isNaN(value)) {
                                if (value > parseFloat(item.max)) {
                                  bgColor = "rgb(255,100,100)";
                                  tmpvalue = "High";
                                } // Red
                                else if (value < parseFloat(item.min)) {
                                  bgColor = "rgba(250,200,0,1)";
                                  tmpvalue = "Low";
                                } // Yellow
                              }

                              return (
                                <div
                                  key={index}
                                  className="metric-card"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: isMobile ? "10px" : "16px",
                                    borderRadius: "2vh",
                                    background: bgColor,
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.6)",
                                    border: "0vh solid",
                                    width: "93%",
                                    maxWidth: "100%",
                                    fontSize: isMobile ? "0.95rem" : "2.2vh",
                                    overflow: "hidden",
                                    gap: "10px",
                                    whiteSpace: "nowrap",
                                    minHeight: "11vh",
                                    height: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      minWidth: "10.0vw",
                                      textAlign: "left",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {item.label}:
                                  </div>
                                  <div
                                    style={{
                                      flex: 1,
                                      textAlign: "right",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "6px",
                                    }}
                                  >
                                    <span>{item.value ?? "--"}</span>
                                    <span>{item.unit ?? ""}</span>
                                    <span style={{ opacity: 0.8 }}>
                                      ({tmpvalue})
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      minWidth: "40px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <img
                                      src={item.icon}
                                      alt={item.label}
                                      style={{
                                        width: isMobile ? "24px" : "5vh",
                                        height: isMobile ? "24px" : "5vh",
                                        filter: item.filter,
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : null}

                      {selectedCardIndex === 1 && currentRole !== "User" ? (
                        <div
                          style={{
                            width: isMobile ? "100%" : "calc(100vw - 350px)",
                            minHeight: "60vh",
                            padding: isMobile ? "10px" : "20px",
                            marginLeft: isMobile ? "10px" : "10px", // Fixed: add 'px' to prevent warning
                            marginBottom: "20px",
                            backgroundColor: "#f0f0f0",
                            alignItems: "center",
                            overflowX: "hidden",
                            overflowY: "auto", // ✅ Enable vertical scroll
                            boxSizing: "border-box",
                          }}
                        >
                          <>
                            {rs4852 === "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex", // Flex container for the row
                                  justifyContent: "center", // Add space between the sliders
                                  marginTop: isMobile ? "30px" : "50px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    Chlorine Low Threshold:{" "}
                                    {Number(c_dolow).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_dolow}
                                    min={0.0}
                                    max={3.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_dolow(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0", // ✅ Removes space beneath the slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ Removes internal spacing
                                      marginTop: "0", // ✅ Prevents vertical gap
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      3.0
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    Chlorine High Threshold:{" "}
                                    {Number(c_dohigh).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_dohigh}
                                    min={0.0}
                                    max={3.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_dohigh(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0", // ✅ Remove space below the slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ No extra padding
                                      marginTop: "0", // ✅ No extra margin
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      3.0
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {rs4852 === "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex", // Flex container for the row
                                  justifyContent: "center", // Add space between the sliders
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    PH Low Threshold:{" "}
                                    {Number(c_phlow).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_phlow}
                                    min={0.0}
                                    max={20.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_phlow(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0px", // ✅ Removes space beneath slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ No padding
                                      marginTop: "0", // ✅ No space above labels
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0px",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0px",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      20.0
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    PH High Threshold:{" "}
                                    {Number(c_phhigh).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_phhigh}
                                    min={0.0}
                                    max={20.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_phhigh(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0px", // ✅ Removes space beneath slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ No padding
                                      marginTop: "0", // ✅ No space above labels
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      20.0
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 === "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex", // Flex container for the row
                                  justifyContent: "center", // Add space between the sliders
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    Temp Low Threshold:{" "}
                                    {Number(c_templow).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_templow}
                                    min={0.0}
                                    max={70.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_templow(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0px", // ✅ Remove gap below slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ Tight layout
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      70.0
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{ color: "#555", fontSize: "2.5vh" }}
                                  >
                                    Temp High Threshold:{" "}
                                    {Number(c_temphigh).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    id="myRange"
                                    value={c_temphigh}
                                    min={0.0}
                                    max={70.0}
                                    step={0.1}
                                    onChange={(e) => {
                                      setc_temphigh(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0px", // ✅ Prevents space under slider
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0", // ✅ No padding
                                      marginTop: "0", // ✅ Removes space above label row
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      70.0
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 === "true" && (
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  width: "92%",
                                  // border:"2px solid",
                                  margin: "auto",
                                  alignSelf: "center",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "92%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "20px",
                                    margin: "10px auto",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      padding: "0px 0px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "3.5vh",
                                        color: "#555",
                                      }}
                                    >
                                      Calibration (FCL)
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      gap: "40px",
                                      marginTop: "0px",
                                      flexDirection: "row",
                                      width: "27%",
                                      alignSelf: "flex-start",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {" "}
                                      <input
                                        type="radio"
                                        name="calibrationMode"
                                        value="0"
                                        accentColor="blue"
                                        checked={calibrationMode2 === "0"}
                                        onChange={(e) => {
                                          setCalibrationMode2(e.target.value);
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              chl_type_mac: message || "",
                                              chl_calibration_type: "0" || "",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }}
                                        style={{
                                          marginRight: "8px",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      0
                                    </label>
                                    <label
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="calibrationMode"
                                        value="5"
                                        checked={calibrationMode2 === "5"}
                                        onChange={(e) => {
                                          setCalibrationMode2(e.target.value);
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              chl_type_mac: message || "",
                                              chl_calibration_type: "5" || "",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }}
                                        style={{
                                          marginRight: "8px",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      5
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      padding: "0px 0px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                      }}
                                    >
                                      Enable/Disable{" "}
                                    </div>

                                    {/* Toggle Switch */}
                                    <label
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                        width: "50px",
                                        height: "28px",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isCalibrated2}
                                        onChange={(e) => {
                                          setIsCalibrated2(e.target.checked);
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              chl_mac: message || "",
                                              chl_calibration: e.target.checked
                                                ? "true"
                                                : "false",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                          if (e.target.checked) {
                                            localStorage.setItem(
                                              "calibrationEnabledAt2",
                                              Date.now().toString()
                                            );
                                            setTimeout(() => {
                                              fetch(`${API_URL}/settings.php`, {
                                                method: "POST",
                                                headers: {
                                                  Accept: "application/json",
                                                  "Content-Type":
                                                    "application/json",
                                                },
                                                body: JSON.stringify({
                                                  chl_mac: message || "",
                                                  chl_calibration: "false",
                                                }),
                                              })
                                                .then((response) =>
                                                  response.json()
                                                )
                                                .then((responseData) => {
                                                  setIsCalibrated2(false);
                                                })
                                                .catch((err) => {
                                                  console.log(err);
                                                });
                                            }, 20000);
                                          } else {
                                            localStorage.removeItem(
                                              "calibrationEnabledAt2"
                                            );
                                          }
                                        }}
                                        style={{
                                          opacity: 0,
                                          width: 0,
                                          height: 0,
                                        }}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          cursor: "pointer",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          backgroundColor: isCalibrated2
                                            ? "#8ec5fc"
                                            : "#ccc",
                                          transition: ".4s",
                                          borderRadius: "34px",
                                        }}
                                      ></span>
                                      <span
                                        style={{
                                          position: "absolute",
                                          content: '""',
                                          height: "22px",
                                          width: "22px",
                                          left: isCalibrated2 ? "26px" : "4px",
                                          bottom: "3px",
                                          backgroundColor: "white",
                                          transition: ".4s",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                    </label>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "92%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "20px",
                                    margin: "10px auto",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      padding: "0px 0px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "3.5vh",
                                        color: "#555",
                                      }}
                                    >
                                      Calibration (PH)
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      gap: "40px",
                                      marginTop: "0px",
                                      flexDirection: "row",
                                      alignSelf: "flex-start",
                                      width: "27%",
                                    }}
                                  >
                                    <label
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {" "}
                                      <input
                                        type="radio"
                                        name="phcalibrationMode"
                                        value="4"
                                        checked={calibrationMode === "4"}
                                        onChange={(e) => {
                                          setCalibrationMode(e.target.value);

                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              ph_type_mac: message || "",
                                              ph_calibration_type: "4" || "",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }}
                                        style={{
                                          marginRight: "8px",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      4
                                    </label>
                                    <label
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                        flexDirection: "row",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="phcalibrationMode"
                                        value="7"
                                        checked={calibrationMode === "7"}
                                        onChange={(e) => {
                                          setCalibrationMode(e.target.value);
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              ph_type_mac: message || "",
                                              ph_calibration_type: "7" || "",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }}
                                        style={{
                                          marginRight: "8px",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      7
                                    </label>
                                  </div>
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      alignItems: "center",
                                      padding: "0px 0px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "2.5vh",
                                        color: "#555",
                                      }}
                                    >
                                      Enable/Disable{" "}
                                    </div>

                                    {/* Toggle Switch */}
                                    <label
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                        width: "50px",
                                        height: "28px",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={isCalibrated}
                                        onChange={(e) => {
                                          setIsCalibrated(e.target.checked);
                                          fetch(`${API_URL}/settings.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              ph_mac: message || "",
                                              ph_calibration: e.target.checked
                                                ? "true"
                                                : "false",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {})
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                          if (e.target.checked) {
                                            localStorage.setItem(
                                              "calibrationEnabledAt",
                                              Date.now().toString()
                                            );
                                            setTimeout(() => {
                                              fetch(`${API_URL}/settings.php`, {
                                                method: "POST",
                                                headers: {
                                                  Accept: "application/json",
                                                  "Content-Type":
                                                    "application/json",
                                                },
                                                body: JSON.stringify({
                                                  ph_mac: message || "",
                                                  ph_calibration: "false",
                                                }),
                                              })
                                                .then((response) =>
                                                  response.json()
                                                )
                                                .then((responseData) => {
                                                  setIsCalibrated(false);
                                                })
                                                .catch((err) => {
                                                  console.log(err);
                                                });
                                            }, 20000);
                                          } else {
                                            localStorage.removeItem(
                                              "calibrationEnabledAt"
                                            );
                                          }
                                        }}
                                        style={{
                                          opacity: 0,
                                          width: 0,
                                          height: 0,
                                        }}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          cursor: "pointer",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          backgroundColor: isCalibrated
                                            ? "#8ec5fc"
                                            : "#ccc",
                                          transition: ".4s",
                                          borderRadius: "34px",
                                        }}
                                      ></span>
                                      <span
                                        style={{
                                          position: "absolute",
                                          content: '""',
                                          height: "22px",
                                          width: "22px",
                                          left: isCalibrated ? "26px" : "4px",
                                          bottom: "3px",
                                          backgroundColor: "white",
                                          transition: ".4s",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                    </label>
                                  </div>
                                  {/* Row 2: Radio Buttons */}
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex",
                                  justifyContent: "center",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Voltage Low Threshold:{" "}
                                    {Number(vollow).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    value={vollow}
                                    min={0.0}
                                    max={0.3}
                                    step={0.01}
                                    onChange={(e) => {
                                      setvollow(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.3
                                    </div>
                                  </div>
                                </div>

                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Voltage High Threshold:{" "}
                                    {Number(volhigh).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    value={volhigh}
                                    min={0.3}
                                    max={0.6}
                                    step={0.01}
                                    onChange={(e) => {
                                      setvolhigh(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.3
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.6
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex",
                                  justifyContent: "center",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                  borderBottomColor: "#ccc",
                                  borderBottom: "2px dashed #aaa",
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Current Low Threshold:{" "}
                                    {Number(currlow).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    value={currlow}
                                    min={0.0}
                                    max={60.0}
                                    step={0.01}
                                    onChange={(e) => {
                                      setcurrlow(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0px",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      60.0
                                    </div>
                                  </div>
                                </div>

                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Current High Threshold:{" "}
                                    {Number(currentHigh).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    value={currentHigh}
                                    min={0.0}
                                    max={100.0}
                                    step={0.01}
                                    onChange={(e) => {
                                      setcurrentHigh(e.target.value);
                                      setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        margin: "0px",
                                        padding: "0",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      100.0
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex",
                                  justifyContent: "center",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                  marginTop: "20px",
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Voltage Offset:{" "}
                                    {Number(voltage_offset).toFixed(2)}
                                  </div>

                                  <input
                                    type="range"
                                    value={voltage_offset}
                                    min={0.0}
                                    max={0.9}
                                    step={0.01}
                                    onChange={(e) => {
                                      setvoltage_offset(e.target.value);
                                      //setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.0
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      0.9
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: "40%" }}>
                                  <button
                                    style={{ width: "100%", fontSize: "13px" }}
                                    onClick={() => {
                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          voltage_offset_mac: message || "",
                                          voltage_offset: voltage_offset,
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => console.log(err));
                                    }}
                                    className="dummy-button"
                                  >
                                    Save Voltage Offset
                                  </button>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "90%",
                                  display: "flex",
                                  justifyContent: "center",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                  borderBottomColor: "#ccc",
                                  borderBottom: "2px dashed #aaa",
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                    }}
                                  >
                                    Current Offset:{" "}
                                    {Number(current_offset)?.toFixed(0)}
                                  </div>

                                  <input
                                    type="range"
                                    value={current_offset}
                                    min={-100}
                                    max={100}
                                    step={1}
                                    onChange={(e) => {
                                      setCurrentOffset(e.target.value);
                                      //setIsDirty(true);
                                    }}
                                    style={{
                                      width: "100%",
                                      background: "#fdfdfd",
                                      accentColor: "#8ec5fc",
                                      marginBottom: "0",
                                      padding: "0",
                                      display: "block",
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "70%",
                                      padding: "0",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      -100
                                    </div>
                                    <div
                                      style={{
                                        color: "#000",
                                        fontSize: "2.5vh",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      100
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: "40%" }}>
                                  <button
                                    style={{ width: "100%", fontSize: "13px" }}
                                    onClick={() => {
                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          current_offset_mac: message || "",
                                          current_offset: current_offset,
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => console.log(err));
                                    }}
                                    className="dummy-button"
                                  >
                                    Save Current Offset
                                  </button>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "88%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 0,
                                  marginTop: "30px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "42%",
                                    paddingLeft: "17px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    onClick={async () => {
                                      setLoadRegister2("0");

                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          load_register_mac: message || "",
                                          load_register: "0",
                                          load_r: loadRegister,
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => console.log(err));
                                    }}
                                    className="dummy-button"
                                    style={{ minWidth: "160px" }}
                                  >
                                    Load Disconnect
                                  </button>
                                </div>
                              </div>
                            )}
                            {currentRole !== "User" && rs4852 !== "true" && (
                              <div
                                className=""
                                style={{
                                  width: "88%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "0px",
                                  alignSelf: "center",
                                  alignContent: "center",
                                  gap: 70,
                                  marginTop: "30px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "42%",
                                    paddingLeft: "17px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-end",
                                    color: "#555",
                                    fontSize: "2.5vh",
                                  }}
                                >
                                  <p
                                    style={{
                                      // lineHeight: "26px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    Add Load
                                  </p>{" "}
                                  <div
                                    style={{
                                      color: "#555",
                                      fontSize: "2.5vh",
                                      marginBottom: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    <input
                                      onChange={async (e) => {
                                        setLoadRegister(e.target.value);
                                        setLoadRegister2(e.target.value);
                                      }}
                                      type="number"
                                      value={loadRegister}
                                      min={1}
                                      style={{
                                        color: "#000",
                                        width: "70px",
                                        textAlign: "center",
                                      }}
                                    />{" "}
                                    <span>R</span>
                                  </div>
                                  <button
                                    onClick={() => {
                                      fetch(`${API_URL}/settings.php`, {
                                        method: "POST",
                                        headers: {
                                          Accept: "application/json",
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          load_register_mac: message || "",
                                          load_register: loadRegister,
                                          load_r: loadRegister,
                                        }),
                                      })
                                        .then((response) => response.json())
                                        .then((responseData) => {})
                                        .catch((err) => console.log(err));
                                    }}
                                    className="dummy-button"
                                    style={{ minWidth: "160px" }}
                                  >
                                    Calibrate
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        </div>
                      ) : null}
                    </div>
                    <div style={{ display: "flex", border: "0px solid" }}>
                      {(sandfilter === "true" || sandfilter === true) &&
                      selectedCardIndex === 4 &&
                      threshold ? (
                        <div
                          style={{
                            width: "50%",
                          }}
                        >
                          <div
                            className="metric-group-card"
                            style={{
                              // background: "linear-gradient(135deg, #ddd, #8ec5fc)",
                              color: "black",
                              padding: isMobile ? "15px" : "0px",
                              borderRadius: "12px",
                              // boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                              width: "95%",
                              maxWidth: "100%",
                              alignItems: "center",
                              overflow: "hidden", // fixed typo
                              textAlign: "center",
                              fontSize: isMobile ? "14px" : "2.2vh",
                              paddingBottom: "10px",
                            }}
                          >
                            {[
                              {
                                label: "PWM",
                                value:
                                  threshold?.run_station?.split(",")[1] || "--",
                                icon: require("../img/timing.png"),
                              },
                              {
                                label: "Station",
                                value:
                                  threshold?.run_station?.split(",")[0] || "--",
                                icon: require("../img/wait-time.png"),
                              },
                              {
                                label: "Stations Reading",
                                value: read ?? "--",
                                icon: require("../img/start.png"),
                              },

                              {
                                label: "RS485",
                                value: rs485command ?? "--",
                                icon: require("../img/chlorine.png"),
                              },
                            ].map((item, index) => (
                              <div
                                key={index}
                                className="metric-card"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: isMobile ? "10px" : "16px",
                                  borderRadius: "2vh",
                                  background:
                                    "linear-gradient(135deg, #ddd, #8ec5fc)",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.6)",
                                  border: "0vh solid",
                                  width: "93%",
                                  maxWidth: "100%",
                                  fontSize: isMobile ? "0.95rem" : "2.2vh",
                                  overflow: "hidden",
                                  gap: "10px",
                                  whiteSpace: "nowrap",
                                  minHeight: "11vh",
                                  height: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    minWidth: "10.0vw",
                                    textAlign: "left",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item.label}:
                                </div>

                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: "right",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    gap: "6px",
                                  }}
                                >
                                  {item.label === "PWM" ||
                                  item.label === "Station" ? (
                                    <>
                                      <span>
                                        {item.value === "undefined" ||
                                        !item.value
                                          ? "0"
                                          : item.value}
                                      </span>
                                      <span>{item.unit ?? ""}</span>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          width: "3vh",
                                          height: "3vh",
                                          borderRadius: "50%",
                                          backgroundColor:
                                            item.value === "true"
                                              ? "#28a745"
                                              : "#dc3545",
                                          border: "2px solid white",
                                          boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                                          marginLeft: isMobile ? "0" : "",
                                          marginTop: isMobile ? "10px" : "0",
                                        }}
                                      />
                                    </>
                                  )}
                                </div>
                                {/* Row content */}
                                {item.label === "Stations Reading" && (
                                  <div
                                    style={{
                                      minWidth: "40px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <label
                                      className="toggle-switch"
                                      style={{
                                        display: "flex-end",
                                        marginLeft: isMobile ? "-80px" : "auto",
                                        marginTop: isMobile ? "100px" : "-40px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={read === "true"}
                                        onChange={async (e) => {
                                          if (e.target.checked) {
                                            sendReadCommand("true", "false");
                                            publishdata("READ");
                                          } else {
                                            sendReadCommand("false", "true");
                                            publishdata("STOP");
                                            publishdata("ADC OFF");
                                          }
                                        }}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </div>
                                )}
                                {item.label === "RS485" && (
                                  <div
                                    style={{
                                      minWidth: "40px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <label
                                      className="toggle-switch"
                                      style={{
                                        display: "flex-end",
                                        marginLeft: isMobile ? "-80px" : "auto",
                                        marginTop: isMobile ? "100px" : "-40px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={rs485command === "true"}
                                        onChange={async (e) => {
                                          if (e.target.checked) {
                                            publishdata("RS485 ENABLE");
                                          } else {
                                            publishdata("RS485 DISABLE");
                                          }
                                          setrs485command(
                                            e.target.checked.toString()
                                          );
                                          fetch(`${API_URL}/getthreshold.php`, {
                                            method: "POST",
                                            headers: {
                                              Accept: "application/json",
                                              "Content-Type":
                                                "application/json",
                                            },
                                            body: JSON.stringify({
                                              pHHigh: phhigh || "",
                                              pHLow: phlow || "",
                                              ORPHigh: orphigh || "",
                                              ORPLow: orplow || "",
                                              DOHigh: dohigh || "",
                                              DOLow: dolow || "",
                                              temperatureHigh: temphigh || "",
                                              temperatureLow: templow || "",
                                              voltageHigh: volhigh || "",
                                              voltageLow: vollow || "",
                                              currentHigh: currentHigh || "",
                                              currentLow: currlow || "",
                                              c_pHHigh: c_phhigh || "",
                                              c_pHLow: c_phlow || "",
                                              c_ORPHigh: c_orphigh || "",
                                              c_ORPLow: c_orplow || "",
                                              c_DOHigh: c_dohigh || "",
                                              c_DOLow: c_dolow || "",
                                              c_temperatureHigh:
                                                c_temphigh || "",
                                              c_temperatureLow: c_templow || "",
                                              c_voltageHigh: c_volhigh || "",
                                              c_voltageLow: c_vollow || "",
                                              c_currentHigh:
                                                c_currentHigh || "",
                                              c_currentLow: c_currlow || "",
                                              mac: message || "",
                                              name: name || "",
                                              time_on: time_on || "",
                                              delay_after_on:
                                                delay_after_on || "",
                                              ph_active_time:
                                                ph_active_time || "",
                                              start_active_on:
                                                start_active_on || "",
                                              dosign_acid_current_gpio:
                                                dosing_gpio || "",
                                              chlorine_pump_time:
                                                chlorine_pump_time || "",
                                              alum_current_gpio:
                                                alum_gpio || "",
                                              run_station: [
                                                move_station,
                                                move_pwm,
                                                move_2,
                                              ]
                                                .filter(Boolean)
                                                .join(","),
                                              o_time_on: o_time_on || "",
                                              o_delay_after_on:
                                                o_delay_after_on || "",
                                              o_ph_active_time:
                                                o_ph_active_time || "",
                                              o_start_active_on:
                                                o_start_active_on || "",
                                              o_dosign_acid_current_gpio:
                                                o_dosing_gpio || "",
                                              o_chlorine_pump_time:
                                                o_chlorine_pump_time || "",
                                              o_alum_current_gpio:
                                                o_alum_gpio || "",

                                              chl_time_on: chl_time_on || "",
                                              chl_delay_after_on:
                                                chl_delay_after_on || "",
                                              chl_ph_active_time:
                                                chl_ph_active_time || "",
                                              chl_start_active_on:
                                                chl_start_active_on || "",
                                              bypass_measure_interval_min:
                                                bypass_measure_interval_min ||
                                                "",
                                              bypass_fill_duration_sec:
                                                bypass_fill_duration_sec || "",
                                              bypass_flush_duration_sec:
                                                bypass_flush_duration_sec || "",
                                              bypass_push_duration_min:
                                                bypass_push_duration_min || "",
                                              bypass_sensor_select:
                                                bypass_sensor_select || "",
                                              bypass_acid_chlorine_delay_min:
                                                bypass_acid_chlorine_delay_min ||
                                                "",
                                              bypass_current_state:
                                                bypass_current_state || "",

                                              chl_dosign_acid_current_gpio:
                                                chl_dosing_gpio || "",
                                              chl_chlorine_pump_time:
                                                chl_chlorine_pump_time || "",
                                              chl_alum_current_gpio:
                                                chl_alum_gpio || "",

                                              stop: stop?.toString() || "",
                                              read_command:
                                                read?.toString() || "",
                                              info: info?.toString() || "",
                                              activemode: activemode || "",
                                              status: status?.toString() || "",
                                              ble_name: ble_name || "",
                                              rs485_command:
                                                e.target.checked.toString() ||
                                                "",
                                            }),
                                          })
                                            .then((response) => response.json())
                                            .then((responseData) => {
                                              alert("Settings Updated");
                                            })
                                            .catch((err) => {
                                              console.log(err);
                                            });
                                        }}
                                      />
                                      <span className="slider"></span>
                                    </label>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}

                      {sandfilter === "true" && selectedCardIndex === 4 ? (
                        <div
                          style={{
                            width: isMobile ? "100%" : "calc(100vw - 350px)",
                            minHeight: "85vh",
                            padding: isMobile ? "10px" : "20px",
                            marginLeft: isMobile ? "10px" : "10px", // Fixed: add 'px' to prevent warning
                            marginBottom: "0px",
                            alignItems: "center",
                            overflowX: "hidden",
                            overflowY: "auto", // ✅ Enable vertical scroll
                            boxSizing: "border-box",
                          }}
                        >
                          <div
                            key={5}
                            className="sand-filter-wrapper"
                            style={{
                              position: "relative",
                              left: "0",
                              top: "0",
                              marginTop: "0px",
                              paddingTop: "0px",
                              width: "90%",
                              height: "100%",
                              maxWidth: "100%",
                              marginLeft: "1px",
                              transition: "all 0.3s ease",
                              cursor: "pointer",
                              overflow: "hidden",
                              paddingLeft: "10px",
                              // backgroundColor: "#f0f0f0",
                              transform: "scale(1.05)",
                            }}
                          >
                            <SandFilterWheel />
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {/* 3 */}
                    <div className="dosing-sections">
                      {dosing === "true" && selectedCardIndex === 2 && (
                        <div className="settings-container">
                          <h2 className="section-title">
                            ⚗️ Acid Dosing Settings
                          </h2>

                          {/* Section: Delays */}
                          <div className="settings-section">
                            <div className="slider-group">
                              <p
                                className="slider-label"
                                style={{
                                  marginBottom:
                                    currentRole === "User" ? "10px" : "0px",
                                }}
                              >
                                Size of Pool:{" "}
                                <span className="slider-value">
                                  {ph_active_time
                                    ?.toString()
                                    ?.replace(" m³", "")}{" "}
                                  m³
                                </span>
                              </p>
                              {currentRole === "User" ? null : (
                                <div
                                  ref={containerRef1}
                                  style={{
                                    position: "relative",
                                    fontSize: "16px",
                                    marginBottom: "20px",
                                    width: "100%",
                                  }}
                                >
                                  {/* Input box */}
                                  <input
                                    type="text"
                                    value={ph_active_time}
                                    placeholder="Select or type pool size"
                                    onChange={(e) => {
                                      setph_active_time(e.target.value);
                                      // setchl_ph_active_time(e.target.value);
                                      setIsDirty(true);
                                      handleChange(e);
                                    }}
                                    onClick={() => setOpen(!open)}
                                    style={{
                                      width: "100%",
                                      height: "40px",
                                      padding: "0 10px",
                                      boxSizing: "border-box",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    ▼
                                  </div>

                                  {/* Options list */}
                                  {open && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "45px",
                                        left: 0,
                                        width: "100%",
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        zIndex: 100,
                                      }}
                                    >
                                      {pool_size.map((opt, idx) => (
                                        <div
                                          key={idx}
                                          onClick={() => {
                                            setph_active_time(opt);
                                            //   setchl_ph_active_time(opt);
                                            setIsDirty(true);
                                            setOpen(false);
                                            settime_on(acid_pump_time[idx]);
                                            setdelay_after_on(
                                              acid_impact_time[idx]
                                            );
                                          }}
                                          style={{
                                            padding: "8px 10px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {opt}
                                        </div>
                                      ))}
                                      {pool_size.filter((opt) =>
                                        opt
                                          .toLowerCase()
                                          .includes(
                                            ph_active_time
                                              ?.toString()
                                              ?.toLowerCase()
                                          )
                                      ).length === 0 && (
                                        <div
                                          style={{
                                            padding: "8px 10px",
                                            color: "#999",
                                          }}
                                        >
                                          No options
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}

                              <SliderCard
                                label="Time ON (sec)"
                                value={time_on}
                                setValue={(e) => {
                                  settime_on(e);
                                  setIsDirty(true);
                                }}
                                min={0}
                                max={180}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Delay After ON (min)"
                                value={delay_after_on}
                                setValue={(e) => {
                                  setdelay_after_on(e);
                                  setIsDirty(true);
                                }}
                                min={0}
                                max={300}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Target PH"
                                value={start_active_on}
                                setValue={(e) => {
                                  setstart_active_on(e);
                                  setIsDirty(true);
                                }}
                                min={6.4}
                                max={7.8}
                                step={0.1}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Times No. to achieve the target"
                                value={chlorine_pump_time}
                                setValue={(e) => {
                                  setchlorine_pump_time(e);
                                  setIsDirty(true);
                                }}
                                min={1}
                                max={8}
                                role={currentRole}
                              />
                            </div>
                          </div>

                          {/* Section: Current */}
                          <div className="settings-section">
                            <h3 className="section-subtitle">⚡ Current</h3>
                            <div className="slider-group">
                              <SliderCard
                                label="Dosing Current Threshold"
                                value={dosing_gpio}
                                setValue={(e) => {
                                  setdosing_gpio(e);
                                  setIsDirty(true);
                                }}
                                min={0.1}
                                max={3.0}
                                step={0.1}
                                role={currentRole}
                              />
                              <div
                                style={{
                                  color: "#000",
                                  fontSize: "17px",
                                  textAlign: "left",
                                }}
                              >
                                Pump current: {Acid_pump_time}
                              </div>
                            </div>
                          </div>

                          <div className="settings-section">
                            <h3 className="section-subtitle">💧 Pumps</h3>
                            <div className="slider-group">
                              {currentRole === "User" ? null : (
                                <>
                                  <p className="slider-label">
                                    Pump Enable{" "}
                                    {pumpMode1 === "manual" && (
                                      <label
                                        className="toggle-switch"
                                        style={{
                                          display: "flex-end",
                                          marginLeft: isMobile ? "0px" : "0px",
                                          marginTop: isMobile ? "0px" : "0px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={pump_enable === "true"}
                                          onChange={async (e) => {
                                            if (e.target.checked) {
                                              setpump_enable("true");
                                              setIsDirty(true);
                                            } else {
                                              setpump_enable("false");
                                              setIsDirty(true);
                                            }
                                          }}
                                        />
                                        <span className="slider"></span>
                                      </label>
                                    )}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "15px",
                                      flexWrap: "wrap",
                                      marginTop: "10px",
                                      alignItems: "center",
                                      // border:"2px solid #000",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {[
                                      { label: "Manual", value: "manual" },
                                      {
                                        label: "Automatic",
                                        value: "automatic",
                                      },
                                      { label: "Disable", value: "disable" },
                                      { label: "3 Sec On", value: "3 sec on" },
                                    ].map((mode) => (
                                      <label
                                        key={mode.label}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          fontSize: "18px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="pumpMode1"
                                          value={mode.value}
                                          checked={pumpMode1 === mode.value}
                                          onChange={(e) => {
                                            setPumpMode1(e.target.value);
                                            setIsDirty(true);
                                            fetch(`${API_URL}/settings.php`, {
                                              method: "POST",
                                              headers: {
                                                Accept: "application/json",
                                                "Content-Type":
                                                  "application/json",
                                              },
                                              body: JSON.stringify({
                                                acid_pump_mac: message || "",
                                                acid_pump: e.target.value,
                                              }),
                                            })
                                              .then((response) =>
                                                response.json()
                                              )
                                              .then((responseData) => {})
                                              .catch((err) => console.log(err));
                                          }}
                                        />
                                        {mode.label}
                                      </label>
                                    ))}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {chl_cu === "true" && selectedCardIndex === 2 ? (
                        <div className="settings-container">
                          <h2 className="section-title">
                            💧 Chl/Cu Dosing Settings
                          </h2>
                          <div className="settings-section">
                            <div className="slider-group">
                              <p
                                className="slider-label"
                                style={{
                                  marginBottom:
                                    currentRole === "User" ? "10px" : "0px",
                                }}
                              >
                                Size of Pool:{" "}
                                <span className="slider-value">
                                  {chl_ph_active_time
                                    ?.toString()
                                    ?.replace(" m³", "")}{" "}
                                  m³
                                </span>
                              </p>
                              {currentRole === "User" ? null : (
                                <div
                                  ref={containerRef2}
                                  style={{
                                    position: "relative",
                                    fontSize: "16px",
                                    marginBottom: "20px",
                                    width: "100%",
                                  }}
                                >
                                  {/* Input box */}
                                  <input
                                    type="text"
                                    value={chl_ph_active_time}
                                    placeholder="Select or type pool size"
                                    onChange={(e) => {
                                      setchl_ph_active_time(e.target.value);
                                      // setph_active_time(e.target.value);
                                      setIsDirty(true);
                                      handleChange2(e);
                                    }}
                                    onClick={() => setOpen2(!open2)}
                                    style={{
                                      height: "40px",
                                      padding: "0 10px",
                                      boxSizing: "border-box",
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      width: "100%",
                                    }}
                                  />
                                  {/* Dropdown arrow */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    ▼
                                  </div>

                                  {/* Options list */}
                                  {open2 && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "45px",
                                        left: 0,
                                        width: "100%",
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        backgroundColor: "#fff",
                                        zIndex: 100,
                                      }}
                                    >
                                      {pool_size.map((opt, idx) => (
                                        <div
                                          key={idx}
                                          onClick={() => {
                                            setchl_ph_active_time(opt);
                                            // setph_active_time(opt);
                                            setIsDirty(true);
                                            setOpen2(false);
                                            setchl_time_on(pump_time[idx]);
                                            setchl_delay_after_on(
                                              impact_time[idx]
                                            );
                                          }}
                                          style={{
                                            padding: "8px 10px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          {opt}
                                        </div>
                                      ))}
                                      {pool_size.filter((opt) =>
                                        opt
                                          .toLowerCase()
                                          .includes(
                                            chl_ph_active_time
                                              ?.toString()
                                              ?.toLowerCase()
                                          )
                                      ).length === 0 && (
                                        <div
                                          style={{
                                            padding: "8px 10px",
                                            color: "#999",
                                          }}
                                        >
                                          No options
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                              <SliderCard
                                label="Time ON (sec)"
                                value={chl_time_on}
                                setValue={(e) => {
                                  setchl_time_on(e);
                                  setIsDirty(true);
                                }}
                                min={0}
                                max={27}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Delay After ON (min)"
                                value={chl_delay_after_on}
                                setValue={(e) => {
                                  setchl_delay_after_on(e);
                                  setIsDirty(true);
                                }}
                                min={0}
                                max={180}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Target Chlorine"
                                value={chl_start_active_on}
                                setValue={(e) => {
                                  setchl_start_active_on(e);
                                  setIsDirty(true);
                                }}
                                min={1}
                                max={3}
                                step={0.1}
                                role={currentRole}
                              />
                              <SliderCard
                                label="Time to Achieve Target"
                                value={chl_chlorine_pump_time}
                                setValue={(e) => {
                                  setchl_chlorine_pump_time(e);
                                  setIsDirty(true);
                                }}
                                min={1}
                                max={8}
                                role={currentRole}
                              />
                            </div>
                          </div>

                          {/* Section: Current */}
                          <div className="settings-section">
                            <h3 className="section-subtitle">⚡ Current</h3>
                            <div className="slider-group">
                              <SliderCard
                                label="Dosing Current Threshold"
                                value={chl_dosing_gpio}
                                setValue={(e) => {
                                  setchl_dosing_gpio(e);
                                  setIsDirty(true);
                                }}
                                min={0.1}
                                max={3.0}
                                step={0.1}
                                role={currentRole}
                              />
                              <div
                                style={{
                                  color: "#000",
                                  fontSize: "17px",
                                  textAlign: "left",
                                }}
                              >
                                Pump current: {Chlorine_pump_time}
                              </div>
                            </div>
                          </div>
                          <div className="settings-section">
                            <h3 className="section-subtitle">💧 Pumps</h3>
                            <div className="slider-group">
                              {currentRole === "User" ? null : (
                                <>
                                  <p className="slider-label">
                                    Pump Enable{" "}
                                    {pumpMode2 === "manual" && (
                                      <label
                                        className="toggle-switch"
                                        style={{
                                          display: "flex-end",
                                          marginLeft: isMobile
                                            ? "-80px"
                                            : "auto",
                                          marginTop: isMobile
                                            ? "100px"
                                            : "-40px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={chl_pump_enable === "true"}
                                          onChange={async (e) => {
                                            if (e.target.checked) {
                                              setchl_pump_enable("true");
                                              setIsDirty(true);
                                            } else {
                                              setchl_pump_enable("false");
                                              setIsDirty(true);
                                            }
                                          }}
                                        />
                                        <span className="slider"></span>
                                      </label>
                                    )}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "15px",
                                      flexWrap: "wrap",
                                      marginTop: "10px",
                                      alignItems: "center",
                                      // border:"2px solid #000",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {[
                                      { label: "Manual", value: "manual" },
                                      {
                                        label: "Automatic",
                                        value: "automatic",
                                      },
                                      { label: "Disable", value: "disable" },
                                      { label: "3 Sec On", value: "3 sec on" },
                                    ].map((mode) => (
                                      <label
                                        key={mode.label}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          fontSize: "18px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="pumpMode2"
                                          value={mode.value}
                                          checked={pumpMode2 === mode.value}
                                          onChange={(e) => {
                                            setPumpMode2(e.target.value);
                                            setIsDirty(true);
                                            fetch(`${API_URL}/settings.php`, {
                                              method: "POST",
                                              headers: {
                                                Accept: "application/json",
                                                "Content-Type":
                                                  "application/json",
                                              },
                                              body: JSON.stringify({
                                                chlorine_pump_mac:
                                                  message || "",
                                                chlorine_pump: e.target.value,
                                              }),
                                            })
                                              .then((response) =>
                                                response.json()
                                              )
                                              .then((responseData) => {})
                                              .catch((err) => console.log(err));
                                          }}
                                        />
                                        {mode.label}
                                      </label>
                                    ))}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {dosing2 === "true" && selectedCardIndex === 2 ? (
                        <div className="settings-container">
                          <h2 className="section-title">
                            🧪 Other Dosing Settings
                          </h2>
                          <div className="settings-section">
                            <div className="slider-group">
                              <div
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Every
                                </span>

                                <input
                                  type="number"
                                  min="1"
                                  value={intervalValue}
                                  onChange={(e) => {
                                    setIsDirty(true);
                                    setIntervalValue(e.target.value);
                                    seto_delay_after_on(
                                      e.target.value + intervalType
                                    ); // combine dynamically
                                  }}
                                  style={{
                                    width: "60px",
                                    padding: "4px",
                                    fontSize: "15px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    textAlign: "center",
                                    minHeight: "35px",
                                  }}
                                />

                                <select
                                  value={intervalType}
                                  onChange={(e) => {
                                    setIsDirty(true);
                                    setIntervalType(e.target.value);
                                    seto_delay_after_on(
                                      intervalValue + e.target.value
                                    );
                                  }}
                                  style={{
                                    padding: "4px",
                                    fontSize: "15px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    minHeight: "35px",
                                  }}
                                >
                                  <option value="day">Day</option>
                                  <option value="week">Week</option>
                                </select>
                              </div>

                              <SliderCard
                                label="Time ON"
                                value={o_time_on}
                                setValue={(e) => {
                                  seto_time_on(e);
                                  setIsDirty(true);
                                }}
                                min={0}
                                max={999}
                                role={currentRole}
                              />
                            </div>
                          </div>
                          <div className="settings-section">
                            <h3 className="section-subtitle">⚡ Current</h3>
                            <div className="slider-group">
                              <SliderCard
                                label="Dosing Current Threshold"
                                value={o_dosing_gpio}
                                setValue={(e) => {
                                  seto_dosing_gpio(e);
                                  setIsDirty(true);
                                }}
                                min={0.1}
                                max={3.0}
                                step={0.1}
                                role={currentRole}
                              />
                              <div
                                style={{
                                  color: "#000",
                                  fontSize: "17px",
                                  textAlign: "left",
                                }}
                              >
                                Pump current: {Other_pump_time}
                              </div>
                            </div>
                          </div>

                          <div className="settings-section">
                            <h3 className="section-subtitle">💧 Pumps</h3>
                            <div className="slider-group">
                              {currentRole === "User" ? null : (
                                <>
                                  <p className="slider-label">
                                    Pump Enable{" "}
                                    {pumpMode3 === "manual" && (
                                      <label
                                        className="toggle-switch"
                                        style={{
                                          display: "flex-end",
                                          marginLeft: isMobile
                                            ? "-80px"
                                            : "auto",
                                          marginTop: isMobile
                                            ? "100px"
                                            : "-40px",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={o_pump_enable === "true"}
                                          onChange={async (e) => {
                                            if (e.target.checked) {
                                              seto_pump_enable("true");
                                              setIsDirty(true);
                                            } else {
                                              seto_pump_enable("false");
                                              setIsDirty(true);
                                            }
                                          }}
                                        />
                                        <span className="slider"></span>
                                      </label>
                                    )}
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "15px",
                                      flexWrap: "wrap",
                                      marginTop: "10px",
                                      alignItems: "center",
                                      // border:"2px solid #000",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {[
                                      { label: "Manual", value: "manual" },
                                      {
                                        label: "Automatic",
                                        value: "automatic",
                                      },
                                      { label: "Disable", value: "disable" },
                                      { label: "3 Sec On", value: "3 sec on" },
                                    ].map((mode) => (
                                      <label
                                        key={mode.label}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          fontSize: "18px",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="pumpMode3"
                                          value={mode.value}
                                          checked={pumpMode3 === mode.value}
                                          onChange={(e) => {
                                            setPumpMode3(e.target.value);
                                            setIsDirty(true);
                                            fetch(`${API_URL}/settings.php`, {
                                              method: "POST",
                                              headers: {
                                                Accept: "application/json",
                                                "Content-Type":
                                                  "application/json",
                                              },
                                              body: JSON.stringify({
                                                other_pump_mac: message || "",
                                                other_pump: e.target.value,
                                              }),
                                            })
                                              .then((response) =>
                                                response.json()
                                              )
                                              .then((responseData) => {})
                                              .catch((err) => console.log(err));
                                          }}
                                        />
                                        {mode.label}
                                      </label>
                                    ))}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {bypass_mode === "true" && selectedCardIndex === 3 ? (
                        <div className="settings-container">
                          <h2 className="section-title">
                            Bypass Mode Settings
                          </h2>
                          <div className="settings-section">
                            <SliderCard
                              label="Bypass Measure Interval Min"
                              value={bypass_measure_interval_min}
                              setValue={(e) => {
                                setbypass_measure_interval_min(e);
                                setIsDirty(true);
                              }}
                              min={1}
                              max={99}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Fill Duration Sec"
                              value={bypass_fill_duration_sec}
                              setValue={(e) => {
                                setbypass_fill_duration_sec(e);
                                setIsDirty(true);
                              }}
                              min={1}
                              max={50}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Flush Duration Sec"
                              value={bypass_flush_duration_sec}
                              setValue={(e) => {
                                setbypass_flush_duration_sec(e);
                                setIsDirty(true);
                              }}
                              min={1}
                              max={99}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Push Duration Min"
                              value={bypass_push_duration_min}
                              setValue={(e) => {
                                setbypass_push_duration_min(e);
                                setIsDirty(true);
                              }}
                              min={5}
                              max={99}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Sensor Select"
                              value={bypass_sensor_select}
                              setValue={(e) => {
                                setbypass_sensor_select(e);
                                setIsDirty(true);
                              }}
                              min={1}
                              max={2}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Acid Chlorine Delay Min"
                              value={bypass_acid_chlorine_delay_min}
                              setValue={(e) => {
                                setbypass_acid_chlorine_delay_min(e);
                                setIsDirty(true);
                              }}
                              min={30}
                              max={120}
                              //  role={currentRole}
                            />
                            <SliderCard
                              label="Bypass Current State"
                              value={bypass_current_state}
                              setValue={(e) => {
                                setbypass_current_state(e);
                                setIsDirty(true);
                              }}
                              min={0}
                              max={99}
                              //  role={currentRole}
                            />

                            <p className="slider-label">
                              Bypass Last Acid Timestamp:{" "}
                              {bypass_last_acid_timestamp}
                            </p>
                            <p className="slider-label">
                              Bypass Last Chlorine Timestamp:{" "}
                              {bypass_last_chlorine_timestamp}
                            </p>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* 5 */}
                </div>
                {modalOpen && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      background: "rgba(0,0,0,0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setModalOpen(false)}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 12,
                        width: 300,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h3>{selectedMode} Settings</h3>

                      <label>Station</label>
                      <input
                        value={station}
                        onChange={(e) => setStation(e.target.value)}
                        style={{ width: "100%", marginBottom: 10 }}
                      />

                      <label>PWM</label>
                      <input
                        value={pwm}
                        type="number"
                        onChange={(e) => setPwm(e.target.value)}
                        style={{ width: "100%", marginBottom: 10 }}
                      />
                      {selectedMode !== "CLOSED" && (
                        <>
                          <label>
                            Timer{" "}
                            {selectedMode === "FILTER"
                              ? "(hr)"
                              : selectedMode === "QDCW"
                              ? "(sec)"
                              : "(min)"}
                          </label>
                          <input
                            value={timer}
                            type="number"
                            onChange={(e) => setTimer(e.target.value)}
                            style={{ width: "100%", marginBottom: 10 }}
                          />
                        </>
                      )}
                      <button onClick={saveModeData} style={{ marginTop: 10 }}>
                        Save
                      </button>
                    </div>
                  </div>
                )}
                <button
                  onClick={async () => {
                    sendthreshold();
                    const settings = {
                      Bypass: {
                        Measure: bypass_measure_interval_min,
                        Fill: bypass_fill_duration_sec,
                        Flush: bypass_flush_duration_sec,
                        Push: bypass_push_duration_min,
                        Sensor: bypass_sensor_select,
                        Delay: bypass_acid_chlorine_delay_min,
                        //  Curr: bypass_current_state,
                      },
                    };
                    const settings2 = {
                      PhORP: {
                        PH_H: phhigh,
                        PH_L: phlow,
                        ORP_H: orphigh,
                        ORP_L: orplow,
                        // "Conductivity_H": dohigh,
                        // "Conductivity_L": dolow,
                        Temp_H: temphigh,
                        Temp_L: templow,
                        Vol_H: volhigh,
                        Vol_L: vollow,
                        Cur_H: currentHigh,
                        Cur_L: currlow,
                        Cali: isCalibrated?.toString(),
                        CaliType: calibrationMode,
                        Load: loadRegister2,
                        VolOff: voltage_offset,
                        CurrOff: current_offset,
                      },
                    };
                    const settings3 = {
                      "Chl/Cu": {
                        Chl_L: c_dolow,
                        Chl_H: c_dohigh,
                        ORP_L: c_orplow,
                        ORP_H: c_orphigh,
                        PH_L: c_phlow,
                        PH_H: c_phhigh,
                        Temp_L: c_templow,
                        Temp_H: c_temphigh,
                        Cali: isCalibrated2?.toString(),
                        Cali_Type: calibrationMode2,
                      },
                    };
                    const settings4 = {
                      AcidDos: {
                        TimeOn: time_on,
                        DelayON: Number(delay_after_on) * 60,
                        "Size of Pool": ph_active_time,
                        "Target PH": start_active_on,
                        Curr: dosing_gpio,
                        "Achieve Target": chlorine_pump_time,
                        // GPIO: alum_gpio,
                        Pump: pump_enable?.toString(),
                        Mode: pumpMode1,
                      },
                    };
                    const settings5 = {
                      OtherDos: {
                        TimeOn: o_time_on,
                        Days: o_delay_after_on,
                        Current: o_dosing_gpio,
                        //  GPIO: o_alum_gpio,
                        Pump: o_pump_enable?.toString(),
                        Mode: pumpMode3,
                      },
                    };
                    const settings6 = {
                      ChlDos: {
                        TimeOn: chl_time_on,
                        DelayON: Number(chl_delay_after_on) * 60,
                        "Size of Pool": chl_ph_active_time,
                        "Target Chl": chl_start_active_on,
                        Curr: chl_dosing_gpio,
                        "Achieve Target": chl_chlorine_pump_time,
                        //  GPIO: chl_alum_gpio,
                        Pump: chl_pump_enable?.toString(),
                        Mode: pumpMode2,
                      },
                    };

                    const settings8 = {
                      "Device Setting": {
                        "Device Enable": enable,
                        "PH/ORP/TEMP": rs485,
                        Chlorine: rs4852,
                        Copper: copper,
                        "Acid Dosing": dosing,
                        "Others Dosing": dosing2,
                        "Chlorine/Copper Dosing": chl_cu,
                        SandFilter: sandfilter,
                        "ByPass Mode": bypass_mode,
                        "Cellular Mode": cellular,
                        "WiFi Mode": cellular === "true" ? "false" : "true",
                        APN: APN || "internet",
                        RS485: rs485command,
                        "Circ Pump": CircPump,
                        name: name,
                      },
                    };
                    // eslint-disable-next-line
                    const settings9 = {
                      "Sand Filter Settings": {
                        "SandFilter Data": sandFilterData,
                        "Circ Pump": CircPump,
                        "Circ Current": CircCurrent,
                        "Circ Threshold": CircThreshold,
                        Mac: Mac,
                      },
                    };
                    publishdata2(JSON.stringify(settings));
                    setTimeout(async () => {
                      publishdata2(JSON.stringify(settings2));
                      setTimeout(async () => {
                        publishdata2(JSON.stringify(settings3));
                        setTimeout(async () => {
                          publishdata2(JSON.stringify(settings4));
                          setTimeout(async () => {
                            publishdata2(JSON.stringify(settings5));
                            setTimeout(async () => {
                              publishdata2(JSON.stringify(settings6));
                            }, 2000);
                          }, 2000);
                        }, 2000);
                      }, 2000);
                    }, 2000);
                  }}
                  className={isDirty ? "save-button active" : "save-button"}
                >
                  Save
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <style>{`
        .save-button {
          background: linear-gradient(135deg, #8ec5fc,rgb(59, 179, 226));
          color: #fff;
          border: none;
          border-radius: 50%;
          height: 63px;
          width: 63px;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
          position: fixed;
          display:flex;
          align-item:center;
          justify-content:center;
          bottom: 20px;
          right: 20px;
          padding-top:20px;
          z-index: 10;
        }

        /* ✨ Glow border animation only when unsaved changes */
        .save-button.active {
          animation: pulse-border 1.5s infinite;
        }

        @keyframes pulse-border {
          0% {
            box-shadow: 0 0 0 0 rgba(59, 179, 226, 0.8);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(59, 179, 226, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(59, 179, 226, 0);
          }
        }
      `}</style>
    </div>
  );
}
export default Settings;
